const GetStartedSvg = () => {
	return (
		<svg
			className='animated'
			id='welcome-svg'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 750 500'
			version='1.1'>
			<g id='svg-bg' className='animable'>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='612.82px 372.25px'
					d='M548.78 361.18h128.08v22.14H548.78z'
				/>
				<path
					d='M647.41 336.5a7.35 7.35 0 0 1 9-3.74 6.91 6.91 0 0 1 12.55-1 4.8 4.8 0 0 1 4.83 7.27'
					className='animable'
					fill='#e0e0e0'
					transform-origin='660.96px 333.611px'
				/>
				<path
					d='M661.81 357.45a17 17 0 0 1-17-17.05v-4h34.1v4a17.05 17.05 0 0 1-17.1 17.05Z'
					className='animable'
					fill='#f5f5f5'
					transform-origin='661.86px 346.925px'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='627.255px 348.355px'
					d='M631.98 357.45h-9.59l-3.55-18.19h16.83l-3.69 18.19z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='611.895px 361.18px'
					d='M536.41 357.45h150.97v7.46H536.41z'
				/>
				<path
					className='animable'
					fill='#ebebeb'
					transform-origin='557.875px 348.355px'
					d='M562.59 357.45H553l-3.54-18.19h16.83l-3.7 18.19z'
				/>
				<path
					className='animable'
					fill='#f5f5f5'
					transform-origin='619.455px 348.355px'
					d='M624.17 357.45h-9.59l-3.54-18.19h16.83l-3.7 18.19z'
				/>
				<path
					d='M577.23 357.45v-37.76a5.27 5.27 0 0 1 5.27-5.28h.22v-8.75h6.76v8.54a5.27 5.27 0 0 1 5.27 5.28v38Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='585.99px 331.57px'
				/>
				<path
					className='animable'
					fill='#f5f5f5'
					transform-origin='548.14px 399.07px'
					d='M546.82 364.9h2.64v68.34h-2.64z'
				/>
				<path
					className='animable'
					fill='#f5f5f5'
					transform-origin='677.53px 399.07px'
					d='M676.21 364.9h2.64v68.34h-2.64z'
				/>
				<circle
					cx='612.82'
					cy='373.79'
					r='3.58'
					className='animable'
					fill='#f5f5f5'
					transform-origin='612.82px 373.79px'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='170.75px 334.545px'
					d='M123.34 244.92h94.82v179.25h-94.82z'
				/>
				<path
					className='animable'
					fill='#f5f5f5'
					transform-origin='142.61px 334.545px'
					d='M95.2 244.92h94.82v179.25H95.2z'
				/>
				<path
					d='M183 281.82h-81.35v-28.41H183Zm-80.39-1H182v-26.41h-79.35Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='142.325px 267.615px'
				/>
				<path
					d='M127.45 253.9h30.89v.71a4.95 4.95 0 0 1-4.95 4.95h-21a4.95 4.95 0 0 1-4.95-4.95v-.71h.01Z'
					className='animable'
					fill='#ebebeb'
					transform-origin='142.89px 256.73px'
				/>
				<path
					d='M183 317.91h-81.35V289.5H183Zm-80.39-1H182V290.5h-79.35Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='142.325px 303.705px'
				/>
				<path
					d='M127.45 290h30.89v.71a4.95 4.95 0 0 1-4.95 4.95h-21a4.95 4.95 0 0 1-4.95-4.95V290h.01Z'
					className='animable'
					fill='#ebebeb'
					transform-origin='142.89px 292.83px'
				/>
				<path
					d='M183 354h-81.35v-28.41H183Zm-80.39-1H182v-26.41h-79.35Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='142.325px 339.795px'
				/>
				<path
					d='M127.45 326.09h30.89v.71a4.95 4.95 0 0 1-4.95 4.95h-21a4.95 4.95 0 0 1-4.95-4.95v-.71h.01Z'
					className='animable'
					fill='#ebebeb'
					transform-origin='142.89px 328.92px'
				/>
				<path
					d='M183 390.09h-81.35v-28.41H183Zm-80.39-1H182v-26.41h-79.35Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='142.325px 375.885px'
				/>
				<path
					d='M127.45 362.18h30.89v.71a4.95 4.95 0 0 1-4.95 4.95h-21a4.95 4.95 0 0 1-4.95-4.95v-.71Z'
					className='animable'
					fill='#ebebeb'
					transform-origin='142.89px 365.01px'
				/>
				<path
					className='animable'
					fill='#ebebeb'
					transform-origin='142.49px 242.675px'
					d='M90.99 238.21h103v8.93h-103z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='209.465px 242.675px'
					d='M193.98 238.21h30.97v8.93h-30.97z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='97.69px 428.75px'
					d='M95.2 424.17h4.98v9.16H95.2z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='128.48px 428.75px'
					d='M125.99 424.17h4.98v9.16h-4.98z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='184.71px 428.75px'
					d='M182.22 424.17h4.98v9.16h-4.98z'
				/>
				<path
					className='animable'
					fill='#e0e0e0'
					transform-origin='212.83px 428.75px'
					d='M210.34 424.17h4.98v9.16h-4.98z'
				/>
				<path
					d='M674.18 228.08a7.29 7.29 0 0 1-.93-.91 12.39 12.39 0 0 1-2-3.12 14.21 14.21 0 0 1-1.29-5.76 13.43 13.43 0 0 1 2.21-7.46 54.28 54.28 0 0 1 6.12-7.22 28.88 28.88 0 0 0 3.18-4.14 13.22 13.22 0 0 0 1.93-5.08 10.52 10.52 0 0 0-.87-5.6 23.5 23.5 0 0 0-3.19-5.13c-1.25-1.64-2.63-3.25-3.9-5a23.86 23.86 0 0 1-3.13-5.78 14.51 14.51 0 0 1-.86-6.54 11.2 11.2 0 0 1 2.56-5.87 8.28 8.28 0 0 1 5.4-3 4.75 4.75 0 0 1 3 .61 3.21 3.21 0 0 1 1.51 2.61 2.82 2.82 0 0 1-1.62 2.44 3.77 3.77 0 0 1-2.84.28 8.86 8.86 0 0 1-4.22-3.25 18.91 18.91 0 0 1-3.63-8.72 28.15 28.15 0 0 1-.06-7.82 53 53 0 0 1 1.05-5.8c.37-1.58.69-2.79.91-3.61l.27-.93a1.93 1.93 0 0 1 .1-.32 1.51 1.51 0 0 1-.05.33c-.06.24-.13.55-.22.95-.19.86-.46 2.07-.81 3.62a53.93 53.93 0 0 0-1 5.79 28.12 28.12 0 0 0 .14 7.73 18.38 18.38 0 0 0 3.6 8.51 8.53 8.53 0 0 0 4 3.08 3.3 3.3 0 0 0 2.5-.25 2.36 2.36 0 0 0 1.36-2 2.72 2.72 0 0 0-1.3-2.2 4.33 4.33 0 0 0-2.69-.53 7.8 7.8 0 0 0-5.06 2.82 10.7 10.7 0 0 0-2.44 5.59 14.09 14.09 0 0 0 .84 6.3 23.77 23.77 0 0 0 3.06 5.66c1.25 1.73 2.62 3.34 3.89 5a24.64 24.64 0 0 1 3.24 5.24 11 11 0 0 1 .88 5.86 13.47 13.47 0 0 1-2 5.26 28.79 28.79 0 0 1-3.25 4.19 54.75 54.75 0 0 0-6.13 7.13 13.29 13.29 0 0 0-2.23 7.26 14.13 14.13 0 0 0 1.19 5.7 13 13 0 0 0 1.93 3.14c.54.61.87.92.85.94Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='676.94px 180.52px'
				/>
				<path
					d='M681.12 68.46c-13.4-1.8-23.26 5.22-27.66 15.92s-2.24 23.25 3.34 33.39c3.1 5.64 7.74 11 14 12.35 5.16 1.06 10.59-.9 14.69-4.2s7-7.82 9.51-12.46c4.44-8.26 7.09-17.6 6.06-26.92-.9-8.16-9.27-16.87-20-18.08'
					className='animable'
					fill='#f5f5f5'
					transform-origin='676.196px 99.2938px'
				/>
				<path
					d='M673 129.24c-.49.69-1.57 3.11-2 3.87a1.37 1.37 0 0 0-.18 1.15 1 1 0 0 0 1.18.38 2.67 2.67 0 0 0 1.06-.83 1.29 1.29 0 1 0 2.51-.56 2.24 2.24 0 0 0 1 .87c.43.13 1-.1 1-.55a1.11 1.11 0 0 0-.34-.76l-2.65-3.33'
					className='animable'
					fill='#f5f5f5'
					transform-origin='674.168px 132.08px'
				/>
				<path
					d='M52.56 352.22a8.33 8.33 0 0 1-.93-.91 12.56 12.56 0 0 1-2-3.13 14.17 14.17 0 0 1-1.28-5.75 13.41 13.41 0 0 1 2.17-7.43 54.33 54.33 0 0 1 6.12-7.23 28.78 28.78 0 0 0 3.18-4.13 13 13 0 0 0 1.92-5.09 10.62 10.62 0 0 0-.86-5.6 24.48 24.48 0 0 0-3.19-5.12c-1.26-1.65-2.64-3.26-3.9-5a23.93 23.93 0 0 1-3.13-5.83 14.46 14.46 0 0 1-.86-6.53 11.13 11.13 0 0 1 2.56-5.87 8.29 8.29 0 0 1 5.39-3 4.77 4.77 0 0 1 3 .62 3.21 3.21 0 0 1 1.51 2.61 2.85 2.85 0 0 1-1.62 2.44 3.83 3.83 0 0 1-2.85.27 8.86 8.86 0 0 1-4.21-3.24 18.73 18.73 0 0 1-3.58-8.71 28.49 28.49 0 0 1-.07-7.81A53.72 53.72 0 0 1 51 262c.37-1.57.7-2.78.92-3.61.11-.38.2-.69.26-.93a1.19 1.19 0 0 1 .11-.31 1.42 1.42 0 0 1-.06.33c0 .24-.12.55-.21.94-.19.86-.47 2.08-.82 3.63a56.1 56.1 0 0 0-1 5.79 28.85 28.85 0 0 0 .14 7.72 18.54 18.54 0 0 0 3.61 8.52 8.38 8.38 0 0 0 4 3.07 3.33 3.33 0 0 0 2.51-.25 2.36 2.36 0 0 0 1.36-2 2.69 2.69 0 0 0-1.3-2.19 4.23 4.23 0 0 0-2.7-.53 7.84 7.84 0 0 0-5.06 2.81 10.76 10.76 0 0 0-2.43 5.6 14.09 14.09 0 0 0 .84 6.3 23.61 23.61 0 0 0 3.06 5.66c1.25 1.73 2.62 3.34 3.89 5a24.39 24.39 0 0 1 3.24 5.24 11.12 11.12 0 0 1 .88 5.85 13.46 13.46 0 0 1-2 5.27A28.6 28.6 0 0 1 57 328a54.68 54.68 0 0 0-6.12 7.14 13.13 13.13 0 0 0-2.23 7.26 14.21 14.21 0 0 0 1.18 5.67 13.24 13.24 0 0 0 1.93 3.14c.49.68.82.99.8 1.01Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='55.3347px 304.685px'
				/>
				<path
					d='M59.5 192.59c-13.4-1.8-23.26 5.23-27.66 15.92s-2.24 23.26 3.34 33.39c3.1 5.64 7.74 11.06 14 12.35 5.15 1.06 10.59-.9 14.68-4.2s7-7.82 9.52-12.45c4.43-8.27 7.08-17.6 6.06-26.93-.9-8.16-9.27-16.86-20-18.08'
					className='animable'
					fill='#f5f5f5'
					transform-origin='54.5745px 223.424px'
				/>
				<path
					d='M51.34 253.38c-.5.69-1.57 3.1-2 3.87a1.33 1.33 0 0 0-.17 1.15 1 1 0 0 0 1.18.38 2.84 2.84 0 0 0 1.06-.83A1.35 1.35 0 0 0 53 259a1.34 1.34 0 0 0 .94-1.64 2.26 2.26 0 0 0 1 .86c.43.14 1-.09 1-.54a1.23 1.23 0 0 0-.34-.77l-2.6-3.29'
					className='animable'
					fill='#f5f5f5'
					transform-origin='52.5242px 256.203px'
				/>
				<path
					d='M605 135.42a3.37 3.37 0 0 1-.52-1.27 5.39 5.39 0 0 1 .7-3.81c1.58-3.19 7.77-4.91 13.12-1.66a4.12 4.12 0 0 1 1.35 2 3.27 3.27 0 0 1-.19 2.52 2.91 2.91 0 0 1-2.19 1.44 5.26 5.26 0 0 1-2.68-.38 9.58 9.58 0 0 1-5.38-9.55 8.41 8.41 0 0 1 2.71-5.57 10 10 0 0 1 5.92-2.62 8.93 8.93 0 0 1 3.36.32 5.9 5.9 0 0 1 2.95 1.79 3.24 3.24 0 0 1 .79 1.64 2.32 2.32 0 0 1-.51 1.79 4 4 0 0 1-3.38 1.13 10.08 10.08 0 0 1-8.78-9.32 9.58 9.58 0 0 1 2-6.15 10.15 10.15 0 0 1 5.07-3.6 7.24 7.24 0 0 1 5.86.49 4.55 4.55 0 0 1 1.85 2.24 3.5 3.5 0 0 1-.1 2.82 4.46 4.46 0 0 1-4.64 2.1 5.88 5.88 0 0 1-3.8-2.91 8.41 8.41 0 0 1-1.18-4.2 9.79 9.79 0 0 1 .72-3.83 11.34 11.34 0 0 1 3.76-4.89 9.11 9.11 0 0 1 3.56-1.61 7.3 7.3 0 0 1 1.36-.16s-.47.06-1.33.26a9.36 9.36 0 0 0-3.47 1.67 10.74 10.74 0 0 0-2 2 10.2 10.2 0 0 0-1.63 2.87 9.7 9.7 0 0 0-.66 3.72 8.23 8.23 0 0 0 1.16 4 5.51 5.51 0 0 0 3.56 2.7 4 4 0 0 0 4.18-1.9 3.59 3.59 0 0 0-1.6-4.47 6.8 6.8 0 0 0-5.48-.42 9.67 9.67 0 0 0-4.81 3.44 9 9 0 0 0-1.88 5.83 9.59 9.59 0 0 0 8.3 8.82 3.55 3.55 0 0 0 2.95-.94 1.79 1.79 0 0 0 .39-1.39 2.81 2.81 0 0 0-.66-1.38 5.44 5.44 0 0 0-2.71-1.63 8.72 8.72 0 0 0-3.17-.31 9.57 9.57 0 0 0-5.62 2.49 7.94 7.94 0 0 0-2.57 5.24 9.15 9.15 0 0 0 5.06 9.11 4.8 4.8 0 0 0 2.46.36 2.47 2.47 0 0 0 1.9-1.21 2.86 2.86 0 0 0 .17-2.22 3.71 3.71 0 0 0-1.21-1.81 8.07 8.07 0 0 0-3.9-1.52 12.82 12.82 0 0 0-3.8-.06 6.8 6.8 0 0 0-5 3.06 5.39 5.39 0 0 0-.77 3.69 6.48 6.48 0 0 0 .41 1.25Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='615.843px 114.795px'
				/>
				<path
					d='M329.3 370.56a3.44 3.44 0 0 1-1.36-.08 5.43 5.43 0 0 1-3.12-2.3c-2.19-2.81-1-9.13 4.22-12.53a4 4 0 0 1 2.38-.35 3.26 3.26 0 0 1 2.18 1.27 2.91 2.91 0 0 1 .34 2.6 5.31 5.31 0 0 1-1.51 2.24 9.58 9.58 0 0 1-10.94.68 8.45 8.45 0 0 1-3.83-4.87 10.05 10.05 0 0 1 .22-6.47 9.09 9.09 0 0 1 1.75-2.88 5.92 5.92 0 0 1 2.9-1.88 3.22 3.22 0 0 1 1.82 0 2.35 2.35 0 0 1 1.4 1.24 4 4 0 0 1-.47 3.54 10.08 10.08 0 0 1-12.21 3.83 9.6 9.6 0 0 1-4.67-4.48 10.12 10.12 0 0 1-1-6.13 7.24 7.24 0 0 1 3-5.06 4.56 4.56 0 0 1 2.82-.69 3.52 3.52 0 0 1 2.49 1.33 4.45 4.45 0 0 1-.14 5.09 5.87 5.87 0 0 1-4.27 2.15 8.51 8.51 0 0 1-4.3-.81 9.85 9.85 0 0 1-3.13-2.31 11.11 11.11 0 0 1-2.76-5.52 9.27 9.27 0 0 1 .11-3.91 6.81 6.81 0 0 1 .45-1.29s-.15.45-.35 1.31a9.52 9.52 0 0 0 0 3.85 11 11 0 0 0 .9 2.64 10.27 10.27 0 0 0 1.87 2.72 9.75 9.75 0 0 0 3.06 2.21 8.22 8.22 0 0 0 4.13.71 5.48 5.48 0 0 0 4-2 4 4 0 0 0 .11-4.59 3.58 3.58 0 0 0-4.72-.51 6.8 6.8 0 0 0-2.77 4.75 9.67 9.67 0 0 0 1 5.82 9.13 9.13 0 0 0 4.43 4.24 9.57 9.57 0 0 0 11.56-3.62 3.53 3.53 0 0 0 .44-3.06 1.76 1.76 0 0 0-1.08-1 2.84 2.84 0 0 0-1.53 0 5.42 5.42 0 0 0-2.65 1.72 8.74 8.74 0 0 0-1.65 2.72 9.55 9.55 0 0 0-.22 6.15 8 8 0 0 0 3.59 4.6 9.16 9.16 0 0 0 10.41-.58 5 5 0 0 0 1.4-2.06 2.48 2.48 0 0 0-.27-2.24 2.85 2.85 0 0 0-1.91-1.12 3.74 3.74 0 0 0-2.17.3 8.09 8.09 0 0 0-3.06 2.85 12.29 12.29 0 0 0-1.71 3.39 6.79 6.79 0 0 0 .56 5.85 5.45 5.45 0 0 0 3 2.31 7.16 7.16 0 0 0 1.26.23Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='317.528px 351.782px'
				/>
				<path
					d='M327.79 158a.75.75 0 0 1 0-.28c.05-.21.12-.47.2-.8a25.42 25.42 0 0 0 .52-3.12 23.6 23.6 0 0 0-1.63-11.4 16.94 16.94 0 0 0-4.46-6.52 8.47 8.47 0 0 0-3.91-1.89 6.6 6.6 0 0 0-4.47.66 3.94 3.94 0 0 0-1.62 1.64 2.24 2.24 0 0 0-.1 2.18 2.09 2.09 0 0 0 2 .93 3.56 3.56 0 0 0 2.19-1 12.8 12.8 0 0 0 1.7-2 21.38 21.38 0 0 0 1.44-2.28 14.42 14.42 0 0 0 1.75-5.16c.51-3.62-1.1-7.54-4.2-9.14a5.71 5.71 0 0 0-4.84-.24 3.88 3.88 0 0 0-2.29 3.79 3.07 3.07 0 0 0 .85 2 3.24 3.24 0 0 0 2 .9 4.46 4.46 0 0 0 3.81-1.57 8.47 8.47 0 0 0 1.78-7.39A8.59 8.59 0 0 0 315 112a9.25 9.25 0 0 0-4.63-1.61 9 9 0 0 0-3.12.32c-.7.19-1 .36-1.06.33a4.78 4.78 0 0 1 1-.43 8.62 8.62 0 0 1 3.17-.42 9.4 9.4 0 0 1 4.79 1.57 9.17 9.17 0 0 1 1.91 13.24 4.91 4.91 0 0 1-4.19 1.73 3.7 3.7 0 0 1-2.24-1 3.51 3.51 0 0 1-1-2.32 4.44 4.44 0 0 1 .59-2.51 4.29 4.29 0 0 1 2-1.76 6.16 6.16 0 0 1 5.28.24 8.26 8.26 0 0 1 3.69 4.06A10.43 10.43 0 0 1 322 129a15 15 0 0 1-1.82 5.35 20.85 20.85 0 0 1-1.48 2.33 13 13 0 0 1-1.76 2.09 4.07 4.07 0 0 1-2.51 1.15 2.6 2.6 0 0 1-2.45-1.18 2.73 2.73 0 0 1 .1-2.66 4.4 4.4 0 0 1 1.82-1.83 7.05 7.05 0 0 1 4.78-.69 8.92 8.92 0 0 1 4.1 2 17.15 17.15 0 0 1 4.53 6.72 23.43 23.43 0 0 1 1.49 11.56 16.7 16.7 0 0 1-1.01 4.16Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='317.584px 134.089px'
				/>
				<path
					d='M686.42 313.55a1.1 1.1 0 0 1 .05-.28c0-.21.12-.48.2-.8a25.28 25.28 0 0 0 .53-3.13 23.85 23.85 0 0 0-1.63-11.4 17 17 0 0 0-4.47-6.52 8.41 8.41 0 0 0-3.91-1.88 6.56 6.56 0 0 0-4.46.66 3.94 3.94 0 0 0-1.63 1.63 2.31 2.31 0 0 0-.1 2.17 2.12 2.12 0 0 0 2 .93 3.61 3.61 0 0 0 2.19-1 13.82 13.82 0 0 0 1.69-2 22.44 22.44 0 0 0 1.44-2.28 14.61 14.61 0 0 0 1.76-5.17c.51-3.61-1.11-7.54-4.2-9.13a5.72 5.72 0 0 0-4.84-.25 3.9 3.9 0 0 0-2.3 3.8 3.1 3.1 0 0 0 .86 2 3.29 3.29 0 0 0 2 .89 4.47 4.47 0 0 0 3.82-1.56 8.47 8.47 0 0 0 1.77-7.4 8.62 8.62 0 0 0-3.48-5.35 9.41 9.41 0 0 0-7.76-1.29c-.7.19-1 .37-1.06.34a5 5 0 0 1 1-.44 8.79 8.79 0 0 1 3.16-.41 9.29 9.29 0 0 1 4.79 1.56 9.19 9.19 0 0 1 1.87 13.28 4.92 4.92 0 0 1-4.19 1.73 3.73 3.73 0 0 1-2.24-1 3.5 3.5 0 0 1-1-2.33 4.47 4.47 0 0 1 .6-2.51 4.27 4.27 0 0 1 2-1.76 6.23 6.23 0 0 1 5.28.24 8.28 8.28 0 0 1 3.7 4.06 10.48 10.48 0 0 1 .78 5.6 14.89 14.89 0 0 1-1.81 5.34 23.17 23.17 0 0 1-1.48 2.34 14 14 0 0 1-1.77 2.09 4.09 4.09 0 0 1-2.5 1.15 2.61 2.61 0 0 1-2.46-1.18 2.76 2.76 0 0 1 .1-2.66 4.4 4.4 0 0 1 1.82-1.83 7.13 7.13 0 0 1 4.79-.7 9 9 0 0 1 4.1 2 17.29 17.29 0 0 1 4.53 6.72 23.39 23.39 0 0 1 1.49 11.55 17.11 17.11 0 0 1-1.03 4.18Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='676.259px 289.609px'
				/>
				<path
					d='M97.62 109.84a1.1 1.1 0 0 1 0-.28c0-.21.12-.48.2-.8a25.65 25.65 0 0 0 .52-3.13 23.6 23.6 0 0 0-1.63-11.4 16.83 16.83 0 0 0-4.46-6.52 8.41 8.41 0 0 0-3.91-1.88 6.56 6.56 0 0 0-4.46.66 3.88 3.88 0 0 0-1.63 1.63 2.31 2.31 0 0 0-.1 2.19 2.12 2.12 0 0 0 2 .93 3.64 3.64 0 0 0 2.19-1 13.31 13.31 0 0 0 1.69-2 22.44 22.44 0 0 0 1.44-2.28 14.4 14.4 0 0 0 1.75-5.17c.51-3.61-1.1-7.54-4.19-9.13a5.72 5.72 0 0 0-4.84-.25 3.9 3.9 0 0 0-2.3 3.8 3.09 3.09 0 0 0 .85 2 3.39 3.39 0 0 0 2 .9 4.51 4.51 0 0 0 3.82-1.57 8.47 8.47 0 0 0 1.77-7.4 8.62 8.62 0 0 0-3.48-5.35 9.41 9.41 0 0 0-7.76-1.29c-.7.19-1 .37-1.06.34a5 5 0 0 1 1-.44 8.79 8.79 0 0 1 3.21-.4A9.29 9.29 0 0 1 85 63.53a9.2 9.2 0 0 1 1.9 13.28 4.93 4.93 0 0 1-4.19 1.73 3.79 3.79 0 0 1-2.25-1 3.53 3.53 0 0 1-1-2.32 4.49 4.49 0 0 1 .6-2.52 4.27 4.27 0 0 1 2-1.76 6.23 6.23 0 0 1 5.28.24A8.26 8.26 0 0 1 91 75.22a10.38 10.38 0 0 1 .79 5.6A15.08 15.08 0 0 1 90 86.16a23.17 23.17 0 0 1-1.5 2.34 14 14 0 0 1-1.77 2.09 4.12 4.12 0 0 1-2.51 1.15 2.6 2.6 0 0 1-2.45-1.18 2.76 2.76 0 0 1 .1-2.66 4.4 4.4 0 0 1 1.82-1.83 7.05 7.05 0 0 1 4.78-.69 8.82 8.82 0 0 1 4.1 2 17.21 17.21 0 0 1 4.54 6.72 23.49 23.49 0 0 1 1.48 11.55 16.88 16.88 0 0 1-.97 4.19Z'
					className='animable'
					fill='#e0e0e0'
					transform-origin='87.3988px 85.9118px'
				/>
			</g>
			<g>
				<path
					d='M689.18 433.54c0 .14-137.27.26-306.57.26S76 433.68 76 433.54s137.25-.26 306.6-.26 306.58.11 306.58.26Z'
					className='animable'
					fill='#263238'
					transform-origin='382.59px 433.54px'
				/>
			</g>
			<g id='character-3' className='animable'>
				<path
					d='M531.11 136.59c2.7 2.41.59 5.78 2 6.38a8.41 8.41 0 0 1 4.73 7.65c-.07 2.85-2.67 5.42-2 8.19.49 2 2.45 3.17 3.8 4.71 3.48 4 2.5 10.51-1 14.44s-8.89 5.68-14.11 6.47a51.18 51.18 0 0 1-22.64-1.72c-3.2-1-6.41-2.36-8.69-4.81s-3.44-6.21-2.06-9.27c1-2.27 3.35-4.23 2.94-6.69a15.78 15.78 0 0 0-1.36-3.14c-1-2.53-.07-5.44 1.38-7.75s3.39-4.29 4.65-6.71 1.73-5.53.16-7.76'
					className='animable'
					fill='#f41760'
					transform-origin='516.177px 160.784px'
				/>
				<path
					d='M539.86 177.88s22.51 20.7 23.17 18.27c3.61-13.18 3.17-30.15 2.83-36.66-.35-.56-.75-1.19-1.22-1.88a8.59 8.59 0 0 0-2-2.07 13.36 13.36 0 0 0-3.08-1.85c-1.06-.33-1.19-1.75-.25-2.06s3.86.52 6.53 2.89 1.71-3.1 1.39-5.1-1-8.21-.46-8.78c.79-.83 1.86-.12 2.12 1.88s1.5 7.95 2.55 7.76-.71-10.33-.71-10.33-.72-2.12.48-2.38c2.17-.47 3.23 10.44 3.3 11.48.06.72 1.2.55 1.11-.22s-2-10.09.23-10.59c1.69-.38.95 9 2.41 10.71s-.16-7.17 1.47-7.46c.61-.11 1.08-.11 1.28 5.11a115.44 115.44 0 0 1-.81 12.58c1 14.37 2.62 58.3-17.15 56.24-23.33-2.43-28.2-21-28.2-21Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='557.93px 176.523px'
				/>
				<path
					d='M456.74 228.08a16.83 16.83 0 0 1 .08-22.15l14-15.87L483 201.5c-.49.33-13.05 16.29-13.05 16.29l17.55 21.86a12.6 12.6 0 0 1 2.08 12l-4.69 11.48-12.83-5.76 1-1.5h9.64l.57-2.31Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='471.447px 226.595px'
				/>
				<path
					d='m499.26 429.57.05-9.23h17.29l.07 13.5-1.07.07c-4.77.27-24.28 1-27.47.07-3.56-1.09 11.13-4.41 11.13-4.41Z'
					className='animable'
					fill='#f41760'
					transform-origin='502.122px 427.389px'
				/>
				<g className='animable' opacity='.6'>
					<path
						d='M510.42 433.92a6 6 0 0 1 2.2-3.69 5.86 5.86 0 0 1 4-1.26v4.83Z'
						className='animable'
						fill='#fff'
						transform-origin='513.52px 431.44px'
					/>
				</g>
				<g className='animable' opacity='.6' id='elebghjkc6t9a'>
					<path
						d='M492.11 431.44s-5.15 1.49-4.51 2.33 20.39.83 29.1.05v-.38l-23 .22s-.59-2.18-1.59-2.22Z'
						className='animable'
						fill='#fff'
						transform-origin='502.122px 432.921px'
					/>
				</g>
				<path
					d='M516.79 433.3h-.29l-.86.06-3.14.13c-2.65.1-6.32.19-10.38.2s-7.72-.06-10.38-.15l-3.14-.13-.85-.05h-.3 1.15l3.15.06a491.798 491.798 0 0 0 20.74-.04l3.15-.08h1.15Z'
					className='animable'
					fill='#263238'
					transform-origin='502.12px 433.495px'
				/>
				<path
					d='M493.64 434a6.31 6.31 0 0 0-.59-1.5 7.65 7.65 0 0 0-1.07-1.21 2.39 2.39 0 0 1 1.25 1.1 2.31 2.31 0 0 1 .41 1.61Z'
					className='animable'
					fill='#263238'
					transform-origin='492.818px 432.645px'
				/>
				<path
					d='M499.07 431c-.05 0-.29-.27-.55-.67a2 2 0 0 1-.37-.77c.05 0 .3.26.55.66s.42.78.37.78Z'
					className='animable'
					fill='#263238'
					transform-origin='498.614px 430.28px'
				/>
				<path
					d='M500.47 430.25c0 .05-.31-.13-.61-.4s-.51-.52-.47-.56.31.13.61.4.51.52.47.56Z'
					className='animable'
					fill='#263238'
					transform-origin='499.93px 429.771px'
				/>
				<path
					d='M501.35 428.62a2 2 0 0 1-.9.12 2.12 2.12 0 0 1-.91-.1 2.17 2.17 0 0 1 .91-.11 1.94 1.94 0 0 1 .9.09Z'
					className='animable'
					fill='#263238'
					transform-origin='500.445px 428.632px'
				/>
				<path
					d='M501.65 427.47a1.74 1.74 0 0 1-1 .29 1.79 1.79 0 0 1-1-.13 5.54 5.54 0 0 1 1-.08 5.15 5.15 0 0 1 1-.08Z'
					className='animable'
					fill='#263238'
					transform-origin='500.65px 427.626px'
				/>
				<path
					d='M498.48 429.49a3.45 3.45 0 0 1-1.11 0 6.2 6.2 0 0 1-1.18-.26 2.92 2.92 0 0 1-.68-.27.67.67 0 0 1-.28-.35.45.45 0 0 1 .17-.44 2.07 2.07 0 0 1 2.89 1.33v.3a2.77 2.77 0 0 0-.5-1 2 2 0 0 0-.95-.61 1.71 1.71 0 0 0-1.33.09c-.17.13-.1.34.09.45a3.23 3.23 0 0 0 .63.27 8.48 8.48 0 0 0 1.14.3c.69.15 1.11.15 1.11.19Z'
					className='animable'
					fill='#263238'
					transform-origin='496.851px 428.884px'
				/>
				<path
					d='M498.19 429.54a1.11 1.11 0 0 1-.13-.77 1.87 1.87 0 0 1 .31-.81 1.09 1.09 0 0 1 .92-.57.45.45 0 0 1 .34.52 1.19 1.19 0 0 1-.18.49 4 4 0 0 1-.53.68 1.66 1.66 0 0 1-.63.45s.22-.2.52-.56a3.62 3.62 0 0 0 .47-.66c.15-.24.25-.66 0-.71s-.56.25-.73.47a1.85 1.85 0 0 0-.31.72 5.34 5.34 0 0 0-.05.75Z'
					className='animable'
					fill='#263238'
					transform-origin='498.839px 428.465px'
				/>
				<path
					d='M516.91 428.9h-1.28a5.64 5.64 0 0 0-2.79 1.16 5.47 5.47 0 0 0-1.73 2.46c-.27.74-.29 1.24-.33 1.24a1.09 1.09 0 0 1 0-.35 4.41 4.41 0 0 1 .18-.94 5.45 5.45 0 0 1 1.75-2.58 5.34 5.34 0 0 1 2.9-1.13 4.74 4.74 0 0 1 1 0c.18.09.3.12.3.14Z'
					className='animable'
					fill='#263238'
					transform-origin='513.838px 431.247px'
				/>
				<path
					d='M515.1 421.16a29.57 29.57 0 0 1 .16 3.55 28.54 28.54 0 0 1-.06 3.56 34.1 34.1 0 0 1-.15-3.56 32.39 32.39 0 0 1 .05-3.55Z'
					className='animable'
					fill='#263238'
					transform-origin='515.156px 424.715px'
				/>
				<path
					d='M508.57 431.67a9.94 9.94 0 0 1-2.52.25 9.31 9.31 0 0 1-2.53-.2c0-.06 1.14 0 2.53 0s2.52-.11 2.52-.05Z'
					className='animable'
					fill='#263238'
					transform-origin='506.045px 431.794px'
				/>
				<path
					d='M512 431.66c.05 0-.09.24-.2.5s-.18.49-.24.48-.09-.27 0-.57.37-.45.44-.41Z'
					className='animable'
					fill='#263238'
					transform-origin='511.757px 432.147px'
				/>
				<path
					d='M513.24 430.07s-.07.22-.25.4-.36.3-.4.25.07-.22.25-.4.36-.32.4-.25Z'
					className='animable'
					fill='#263238'
					transform-origin='512.911px 430.392px'
				/>
				<path
					d='M515.06 429.34c0 .06-.24.06-.49.15s-.44.22-.48.18.1-.28.41-.38.58-.01.56.05Z'
					className='animable'
					fill='#263238'
					transform-origin='514.572px 429.461px'
				/>
				<path
					d='M516.37 429c0 .06-.08.15-.23.2s-.27.06-.29 0 .07-.15.22-.2.27-.06.3 0Z'
					className='animable'
					fill='#263238'
					transform-origin='516.109px 429.1px'
				/>
				<path
					d='M552.25 430.12v-9.23h-17.34l-.07 13.51 1.08.07c4.77.26 24.27 1 27.46.06 3.56-1.09-11.13-4.41-11.13-4.41Z'
					className='animable'
					fill='#f41760'
					transform-origin='549.388px 427.941px'
				/>
				<g className='animable' opacity='.6'>
					<path
						d='M541.1 434.47a6 6 0 0 0-2.21-3.69 5.85 5.85 0 0 0-4-1.26v4.84Z'
						className='animable'
						fill='#fff'
						transform-origin='537.995px 431.989px'
					/>
				</g>
				<g className='animable' opacity='.6'>
					<path
						d='M559.41 432s5.14 1.49 4.5 2.34-20.38.82-29.09 0v-.38l23 .22s.58-2.18 1.59-2.18Z'
						className='animable'
						fill='#fff'
						transform-origin='549.393px 433.483px'
					/>
				</g>
				<path
					d='M534.72 433.85h.3l.85.05 3.14.14c2.66.1 6.33.18 10.38.19s7.72-.06 10.38-.15l3.14-.13h1.15-1.15l-3.14.06c-2.66 0-6.33.1-10.38.09s-7.72-.07-10.37-.13l-3.15-.07h-.85Z'
					className='animable'
					fill='#263238'
					transform-origin='549.39px 434.04px'
				/>
				<path
					d='M557.87 434.55a8.06 8.06 0 0 1 .59-1.5 6.24 6.24 0 0 1 1.08-1.2 2.26 2.26 0 0 0-1.26 1.09 2.38 2.38 0 0 0-.41 1.61Z'
					className='animable'
					fill='#263238'
					transform-origin='558.698px 433.2px'
				/>
				<path
					d='M552.44 431.55s.3-.27.55-.66.42-.75.37-.78-.29.27-.55.66a2 2 0 0 0-.37.78Z'
					className='animable'
					fill='#263238'
					transform-origin='552.904px 430.829px'
				/>
				<path
					d='M551.05 430.81s.31-.14.61-.41.5-.52.47-.56-.32.14-.61.4-.52.52-.47.57Z'
					className='animable'
					fill='#263238'
					transform-origin='551.588px 430.322px'
				/>
				<path
					d='M550.16 429.17a2.06 2.06 0 0 0 .9.12 2.17 2.17 0 0 0 .91-.09 2 2 0 0 0-.9-.12 2 2 0 0 0-.91.09Z'
					className='animable'
					fill='#263238'
					transform-origin='551.065px 429.183px'
				/>
				<path
					d='M549.86 428a1.81 1.81 0 0 0 1 .3 1.86 1.86 0 0 0 1-.14 5.24 5.24 0 0 0-1-.07 5.59 5.59 0 0 0-1-.09Z'
					className='animable'
					fill='#263238'
					transform-origin='550.86px 428.159px'
				/>
				<path
					d='M553 430a3.27 3.27 0 0 0 1.11 0 8.37 8.37 0 0 0 1.19-.26 4.09 4.09 0 0 0 .68-.28.61.61 0 0 0 .27-.35.42.42 0 0 0-.17-.44 2 2 0 0 0-2.52.59 2 2 0 0 0-.36.74.58.58 0 0 0 0 .3 3.37 3.37 0 0 1 .51-.94 2 2 0 0 1 .95-.62 1.69 1.69 0 0 1 1.32.09c.18.13.11.34-.09.46a3.38 3.38 0 0 1-.62.26 7.29 7.29 0 0 1-1.15.3c-.66.15-1.12.15-1.12.15Z'
					className='animable'
					fill='#263238'
					transform-origin='554.63px 429.375px'
				/>
				<path
					d='M553.32 430.1a1.11 1.11 0 0 0 .13-.78 2 2 0 0 0-.3-.81 1.17 1.17 0 0 0-.93-.57.46.46 0 0 0-.34.52 1.2 1.2 0 0 0 .19.49 3.26 3.26 0 0 0 .52.68 1.64 1.64 0 0 0 .64.45s-.22-.2-.53-.55a3.72 3.72 0 0 1-.46-.67c-.16-.24-.26-.66 0-.71s.56.25.73.47a1.83 1.83 0 0 1 .31.73 4 4 0 0 1 .04.75Z'
					className='animable'
					fill='#263238'
					transform-origin='552.673px 429.02px'
				/>
				<path
					d='M534.61 429.45s.49-.05 1.27.05a5.49 5.49 0 0 1 2.79 1.15 5.7 5.7 0 0 1 1.74 2.46c.26.74.29 1.24.33 1.24a1.59 1.59 0 0 0 0-.35 4.36 4.36 0 0 0-.19-.93 5.27 5.27 0 0 0-4.65-3.72 4.64 4.64 0 0 0-.95 0 1 1 0 0 0-.34.1Z'
					className='animable'
					fill='#263238'
					transform-origin='537.68px 431.838px'
				/>
				<path
					d='M536.41 421.71a28.48 28.48 0 0 0-.15 3.55 29.77 29.77 0 0 0 0 3.56 28.48 28.48 0 0 0 .15-3.55 29.87 29.87 0 0 0 0-3.56Z'
					className='animable'
					fill='#263238'
					transform-origin='536.335px 425.265px'
				/>
				<path
					d='M542.94 432.22a9.94 9.94 0 0 0 2.52.25 9.31 9.31 0 0 0 2.53-.2c0-.06-1.13 0-2.52 0s-2.47-.11-2.53-.05Z'
					className='animable'
					fill='#263238'
					transform-origin='545.465px 432.344px'
				/>
				<path
					d='M539.55 432.21s.09.24.21.5.18.49.24.48.08-.27 0-.57-.41-.45-.45-.41Z'
					className='animable'
					fill='#263238'
					transform-origin='539.801px 432.697px'
				/>
				<path
					d='M538.28 430.62s.07.22.24.4.36.3.4.26-.07-.22-.25-.41-.35-.29-.39-.25Z'
					className='animable'
					fill='#263238'
					transform-origin='538.604px 430.949px'
				/>
				<path
					d='M536.45 429.89c0 .06.24.06.49.15s.44.22.49.18-.1-.27-.42-.38-.58 0-.56.05Z'
					className='animable'
					fill='#263238'
					transform-origin='536.944px 430.01px'
				/>
				<path
					d='M535.15 429.55c0 .05.08.14.22.19s.28.06.3 0-.08-.14-.22-.2-.28-.05-.3.01Z'
					className='animable'
					fill='#263238'
					transform-origin='535.411px 429.64px'
				/>
				<path
					className='animable'
					fill='#455a64'
					transform-origin='521.225px 337.055px'
					d='m484.19 249.02 8.4 177.41 26.92.56-6.98-153.3 18.23 152.65 27.5.69-21.52-179.95'
				/>
				<path
					d='M505.27 426.69c-.14 0-2.07-39.64-4.3-88.54s-3.92-88.57-3.78-88.58 2.07 39.63 4.3 88.55 3.93 88.57 3.78 88.57Z'
					className='animable'
					fill='#263238'
					transform-origin='501.231px 338.13px'
				/>
				<path
					d='M545.47 425.27c-.15 0-5-38.49-10.79-86s-10.41-86-10.26-86.06 5 38.48 10.78 86 10.41 86.04 10.27 86.06Z'
					className='animable'
					fill='#263238'
					transform-origin='534.945px 339.24px'
				/>
				<path
					d='m501.61 164.6-4.92.9a25.32 25.32 0 0 0-13.81 7.5l-17.71 21.12L481.81 207l9.19-10.75s-1.33 6.59-1.06 7.6a7.59 7.59 0 0 0 2.16 3.07l-.29 18.08-7.62 24 52.55.55-4-25.48.74-25.94 8.82 10 15.06-17.73-17-17.09a30.26 30.26 0 0 0-11.71-7.58 24.14 24.14 0 0 0-6.71-1.36'
					className='animable'
					fill='#263238'
					transform-origin='511.265px 206.96px'
				/>
				<path
					d='M524.56 205.62a3.11 3.11 0 0 1-1.29.81 8.37 8.37 0 0 1-7.18-.38 3.3 3.3 0 0 1-1.2-1 13.37 13.37 0 0 0 4.77 1.43 13.21 13.21 0 0 0 4.9-.86Z'
					className='animable'
					fill='#fafafa'
					transform-origin='519.725px 206.056px'
				/>
				<path
					d='M482.26 172.84a2.42 2.42 0 0 1 .92-.37 5.15 5.15 0 0 1 2.71.13 4.87 4.87 0 0 1 3 2.64 5.17 5.17 0 0 1-.34 4.89 5 5 0 0 1-4.41 2.11 4.4 4.4 0 0 1-3.44-2.06 4.56 4.56 0 0 1-.74-2.61 2.06 2.06 0 0 1 .21-1c.05 0 0 .36 0 1A4.61 4.61 0 0 0 481 180a4.06 4.06 0 0 0 3.16 1.78 4.56 4.56 0 0 0 3.94-1.92 4.72 4.72 0 0 0 .34-4.4 4.54 4.54 0 0 0-2.7-2.49 5.43 5.43 0 0 0-2.55-.28 7.1 7.1 0 0 1-.93.15Z'
					className='animable'
					fill='#fafafa'
					transform-origin='484.653px 177.299px'
				/>
				<path
					d='M505.13 177.48a.87.87 0 0 1 .3.08 3.14 3.14 0 0 1 .81.42 5.35 5.35 0 0 1 2.23 5 4.73 4.73 0 0 1-1.13 2.46 5.22 5.22 0 0 1-9.27-3.12 4.87 4.87 0 0 1 .54-2.65 5.51 5.51 0 0 1 1.55-1.77 5.38 5.38 0 0 1 3.16-1.07 3.49 3.49 0 0 1 .91.09c.2 0 .3.09.3.11s-.44-.06-1.2 0a5.41 5.41 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 4.76 4.76 0 0 0 8.43 2.84 4.23 4.23 0 0 0 1.06-2.2 4.81 4.81 0 0 0-.16-2.16 5.23 5.23 0 0 0-1.76-2.63c-.6-.46-1.01-.6-.99-.65Z'
					className='animable'
					fill='#fafafa'
					transform-origin='503.281px 182.099px'
				/>
				<path
					d='M483.79 191.11s.12 0 .31.08a3 3 0 0 1 .81.42 5.16 5.16 0 0 1 2 2.67 5.24 5.24 0 0 1 .24 2.34 4.73 4.73 0 0 1-1.13 2.46 5.22 5.22 0 0 1-9.27-3.12 4.75 4.75 0 0 1 .54-2.65 5.52 5.52 0 0 1 4.71-2.85 3.79 3.79 0 0 1 .9.1c.21.05.31.09.3.1s-.43 0-1.19 0a5.49 5.49 0 0 0-2.95 1.16 4.68 4.68 0 0 0-1.84 4.09 4.77 4.77 0 0 0 8.44 2.84 4.38 4.38 0 0 0 1.06-2.2 5 5 0 0 0-.16-2.17 5.24 5.24 0 0 0-1.76-2.62c-.61-.46-1.03-.6-1.01-.65Z'
					className='animable'
					fill='#fafafa'
					transform-origin='481.961px 195.735px'
				/>
				<path
					d='M521.56 188.78s.11 0 .3.08a3.14 3.14 0 0 1 .81.42 5.35 5.35 0 0 1 2.23 5 4.73 4.73 0 0 1-1.13 2.46 5.22 5.22 0 0 1-9.27-3.12 4.85 4.85 0 0 1 .5-2.62 5.51 5.51 0 0 1 1.55-1.77 5.38 5.38 0 0 1 3.16-1.07 3.49 3.49 0 0 1 .91.09c.2.05.3.09.3.11s-.44-.06-1.2 0a5.41 5.41 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 4.76 4.76 0 0 0 8.43 2.84 4.23 4.23 0 0 0 1.06-2.2 4.81 4.81 0 0 0-.16-2.16 5.23 5.23 0 0 0-1.76-2.63c-.51-.46-.97-.63-.95-.68Z'
					className='animable'
					fill='#fafafa'
					transform-origin='519.709px 193.414px'
				/>
				<path
					d='M545.45 186.44a.89.89 0 0 1 .31.08 3.71 3.71 0 0 1 .81.42 5.33 5.33 0 0 1 2.22 5 4.66 4.66 0 0 1-1.13 2.46 5.48 5.48 0 0 1-5.71 1.66 5.55 5.55 0 0 1-3.56-4.78 4.87 4.87 0 0 1 .55-2.65 5.15 5.15 0 0 1 1.55-1.76 5.33 5.33 0 0 1 3.15-1.08 3.93 3.93 0 0 1 .91.09c.2.06.3.09.3.11s-.44-.05-1.2 0a5.43 5.43 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 5.1 5.1 0 0 0 3.24 4.32 5 5 0 0 0 5.19-1.47 4.31 4.31 0 0 0 1.07-2.21 5 5 0 0 0-.16-2.16 5.29 5.29 0 0 0-1.76-2.63c-.61-.45-1.02-.6-1-.65Z'
					className='animable'
					fill='#fafafa'
					transform-origin='543.602px 191.04px'
				/>
				<path
					d='M530.43 171.91a.87.87 0 0 1 .3.08 3.71 3.71 0 0 1 .81.42 5.14 5.14 0 0 1 2 2.68 5.06 5.06 0 0 1 .24 2.33 4.73 4.73 0 0 1-1.13 2.46 5.47 5.47 0 0 1-5.72 1.65 5.53 5.53 0 0 1-3.55-4.77 4.87 4.87 0 0 1 .54-2.65 5.54 5.54 0 0 1 4.71-2.84 3.83 3.83 0 0 1 .9.09c.21 0 .31.09.31.11s-.44-.05-1.2 0a5.38 5.38 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 4.77 4.77 0 0 0 8.43 2.85 4.38 4.38 0 0 0 1.06-2.21 4.81 4.81 0 0 0-.16-2.16 5.23 5.23 0 0 0-1.76-2.63c-.61-.46-1.02-.57-1-.66Z'
					className='animable'
					fill='#fafafa'
					transform-origin='528.594px 176.517px'
				/>
				<path
					d='M525.41 213.25s.11 0 .31.08a3 3 0 0 1 .81.42 5.16 5.16 0 0 1 2 2.67 5.24 5.24 0 0 1 .24 2.34 4.67 4.67 0 0 1-1.14 2.46 5.23 5.23 0 0 1-9.27-3.12 4.84 4.84 0 0 1 .55-2.65 5.4 5.4 0 0 1 1.55-1.77 5.48 5.48 0 0 1 3.16-1.08 3.79 3.79 0 0 1 .9.1c.2.05.31.08.3.1s-.43-.05-1.2 0a5.49 5.49 0 0 0-2.94 1.16 4.68 4.68 0 0 0-1.84 4.09 4.76 4.76 0 0 0 8.43 2.84 4.32 4.32 0 0 0 1.07-2.2 5 5 0 0 0-.16-2.17 5.19 5.19 0 0 0-1.76-2.62c-.61-.46-1.03-.6-1.01-.65Z'
					className='animable'
					fill='#fafafa'
					transform-origin='523.578px 217.867px'
				/>
				<path
					d='M523.83 235s.11 0 .31.07a3.71 3.71 0 0 1 .81.42 5.37 5.37 0 0 1 2.23 5A4.74 4.74 0 0 1 526 243a5.22 5.22 0 0 1-9.26-3.13 4.78 4.78 0 0 1 .54-2.65 5.46 5.46 0 0 1 1.55-1.76 5.33 5.33 0 0 1 3.16-1.08 3.33 3.33 0 0 1 .9.1c.21 0 .31.08.3.1s-.43-.05-1.19 0a5.51 5.51 0 0 0-2.95 1.17 4.67 4.67 0 0 0-1.84 4.09 5.09 5.09 0 0 0 3.25 4.31 5 5 0 0 0 5.18-1.47 4.31 4.31 0 0 0 1.07-2.21 5 5 0 0 0-.16-2.16 5.19 5.19 0 0 0-1.76-2.62c-.56-.52-.98-.69-.96-.69Z'
					className='animable'
					fill='#fafafa'
					transform-origin='521.969px 239.648px'
				/>
				<path
					d='M497.77 237.16a.87.87 0 0 1 .3.08 3.71 3.71 0 0 1 .81.42 5.14 5.14 0 0 1 2 2.68 5.06 5.06 0 0 1 .24 2.33 4.73 4.73 0 0 1-1.13 2.46 5.47 5.47 0 0 1-5.72 1.65 5.53 5.53 0 0 1-3.55-4.77 4.87 4.87 0 0 1 .54-2.65 5.54 5.54 0 0 1 4.71-2.84 3.83 3.83 0 0 1 .9.09c.21 0 .31.09.31.11s-.44-.05-1.2 0a5.38 5.38 0 0 0-2.94 1.17 4.63 4.63 0 0 0-1.85 4.08 5.11 5.11 0 0 0 3.25 4.32 5.05 5.05 0 0 0 5.19-1.47 4.38 4.38 0 0 0 1.06-2.21 4.81 4.81 0 0 0-.16-2.16 5.23 5.23 0 0 0-1.76-2.63c-.61-.46-1.03-.61-1-.66Z'
					className='animable'
					fill='#fafafa'
					transform-origin='495.934px 241.767px'
				/>
				<path
					d='M503.49 201.42s.11 0 .31.08a3.5 3.5 0 0 1 .81.42 5.21 5.21 0 0 1 2 2.67 5.26 5.26 0 0 1 .23 2.34 4.73 4.73 0 0 1-1.13 2.46 5.23 5.23 0 0 1-9.27-3.12 4.77 4.77 0 0 1 .55-2.65 5.45 5.45 0 0 1 4.7-2.84 3.44 3.44 0 0 1 .91.09c.2 0 .3.09.3.11s-.44-.06-1.2 0a5.43 5.43 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 4.76 4.76 0 0 0 8.43 2.84 4.25 4.25 0 0 0 1.07-2.2 5 5 0 0 0-.17-2.16 5.29 5.29 0 0 0-1.75-2.63c-.62-.47-1.03-.61-1.01-.66Z'
					className='animable'
					fill='#fafafa'
					transform-origin='501.653px 206.041px'
				/>
				<path
					d='M508.5 221.29s.11 0 .31.08a3.31 3.31 0 0 1 .81.42 5.21 5.21 0 0 1 2 2.67 5.26 5.26 0 0 1 .23 2.34 4.58 4.58 0 0 1-1.13 2.46 5.23 5.23 0 0 1-9.27-3.12 4.85 4.85 0 0 1 .55-2.65 5.29 5.29 0 0 1 1.55-1.77 5.38 5.38 0 0 1 3.15-1.07 3.44 3.44 0 0 1 .91.09c.2 0 .3.09.3.11s-.44-.06-1.2 0a5.43 5.43 0 0 0-2.94 1.17 4.6 4.6 0 0 0-1.84 4.08 5.1 5.1 0 0 0 3.24 4.32 5 5 0 0 0 5.19-1.48 4.25 4.25 0 0 0 1.07-2.2 5 5 0 0 0-.16-2.16 5.29 5.29 0 0 0-1.77-2.58c-.6-.52-1.02-.66-1-.71Z'
					className='animable'
					fill='#fafafa'
					transform-origin='506.664px 225.911px'
				/>
				<path
					d='M503.36 165.39c0-3.35-.06-6.27-.06-6.27s-6.77-.72-7.18-7.43 0-22.19 0-22.19l12.33-6L522 133.75l-1.43 31.95a8.61 8.61 0 0 1-8.6 8.23 8.61 8.61 0 0 1-8.61-8.54Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='508.969px 148.715px'
				/>
				<path
					d='M498 140.2a.86.86 0 1 0 .86-.86.86.86 0 0 0-.86.86Z'
					className='animable'
					fill='#263238'
					transform-origin='498.86px 140.2px'
				/>
				<path
					d='M496.74 139.85c.11.11.74-.43 1.67-.48s1.61.4 1.71.27-.07-.26-.37-.47a2.34 2.34 0 0 0-1.38-.36 2.3 2.3 0 0 0-1.32.53c-.28.24-.37.46-.31.51Z'
					className='animable'
					fill='#263238'
					transform-origin='498.436px 139.336px'
				/>
				<circle
					cx='508.97'
					cy='140.2'
					r='.86'
					className='animable'
					fill='#263238'
					transform-origin='508.97px 140.2px'
				/>
				<path
					d='M507 139.85c.11.11.74-.43 1.67-.48s1.62.4 1.71.27-.06-.26-.37-.47a2.34 2.34 0 0 0-1.38-.36 2.3 2.3 0 0 0-1.32.53c-.31.24-.38.46-.31.51Z'
					className='animable'
					fill='#263238'
					transform-origin='508.691px 139.336px'
				/>
				<path
					d='M503.65 147.66a4.42 4.42 0 0 1-1.52.13 1.64 1.64 0 0 1-.42 0 .61.61 0 0 1-.43-.36 1.54 1.54 0 0 1 .08-1c.2-.63.39-1.26.6-1.93a26 26 0 0 1 1.84-4.86 25.47 25.47 0 0 1-1.34 5l-.64 1.92a1.3 1.3 0 0 0-.14.7c0 .13.22.17.46.19a4.52 4.52 0 0 1 1.51.21Z'
					className='animable'
					fill='#263238'
					transform-origin='502.516px 143.724px'
				/>
				<path
					d='M503.3 159.12a16.1 16.1 0 0 0 8.57-3s-1.83 4.93-8.56 4.65Z'
					className='animable'
					fill='#eb996e'
					transform-origin='507.585px 158.451px'
				/>
				<path
					d='M531.93 139.34v1.19c-.14-1.24-.49-4.06-.69-4.83-3.66-14-16-16.61-18.39-16.61-2.61 0-7.11-1.36-13.83 5.48-5.53 5.63-4.4 13.7-4.4 13.7l2.5-.37 9.82-2.54c1.41-3 2.08-5.3 2.73-6.83a12.44 12.44 0 0 0 11.38 10.4l-.18 20.07c13.07-2.78 11.06-19.66 11.06-19.66Z'
					className='animable'
					fill='#f41760'
					transform-origin='513.283px 138.99px'
				/>
				<path
					d='M505.48 149.89a1.28 1.28 0 0 0-1.63.12 1.21 1.21 0 0 0 0 1.61 1.14 1.14 0 0 0 1.6 0 1.22 1.22 0 0 0 .25-1.12 1.63 1.63 0 0 0-.71-.94'
					className='animable'
					fill='#eb996e'
					transform-origin='504.644px 150.754px'
				/>
				<path
					d='M506.21 148.44c.06 0 .08.32-.09.77a3.16 3.16 0 0 1-1.12 1.49 3.09 3.09 0 0 1-1.8.55c-.49 0-.77-.13-.76-.2a7.54 7.54 0 0 0 2.26-.78c1.05-.75 1.36-1.88 1.51-1.83Z'
					className='animable'
					fill='#263238'
					transform-origin='504.347px 149.844px'
				/>
				<path
					d='M509.91 137.44c-.1.1-.72-.55-1.7-.59s-1.65.54-1.75.43.05-.27.36-.51a2.13 2.13 0 0 1 1.42-.44 2.2 2.2 0 0 1 1.37.57c.28.27.39.5.3.54Z'
					className='animable'
					fill='#263238'
					transform-origin='508.185px 136.889px'
				/>
				<path
					d='M529.06 136.09a10.13 10.13 0 0 1 1.92-4.5 5 5 0 0 1 4.33-1.9 3.89 3.89 0 0 1 3.06 5.34 4.82 4.82 0 0 1-4.72 2.67 8.11 8.11 0 0 1-5.07-2.52'
					className='animable'
					fill='#f41760'
					transform-origin='533.623px 133.695px'
				/>
			</g>
			<g id='character-2' className='animable'>
				<path
					d='m407 171.52 25 6.48s20.67-22.94 21.64-23.74 13.65 3.22 13.65 3.22l-14.73 27.27c-3.51 8.89-8.74 13.91-13.82 14.13l-41-8.14Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='432.515px 176.517px'
				/>
				<path
					d='M452.77 155.28s2.85-5.73 3.25-6.59a78.75 78.75 0 0 0 2.48-7.69s1.7-.37 1.59 3.43.66 2.75.66 2.75 7.9-9.6 9.82-9c.71.24-.27 2.52-1.58 3.75a26.52 26.52 0 0 0-2.72 3.23s7.43-6.7 9.13-5.65c0 0 .83.66-1.53 2.64a53.05 53.05 0 0 0-5.5 5.3s7.37-5.19 8.2-4.63c1.39.93-6.09 6.23-7.32 8.2 0 0 5.55-4.26 5.7-2.89s-6.76 6.17-9.92 13.14Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='464.756px 149.711px'
				/>
				<path
					d='M458.71 148.14s.64.12 1.39.83a5.11 5.11 0 0 1 1.6 3.59l-.46-.17a6 6 0 0 1 3.45-2 2.86 2.86 0 0 1 1.63 0c0 .09-.62.07-1.55.33a6.33 6.33 0 0 0-3.13 1.93l-.45.49v-.65a5.33 5.33 0 0 0-1.34-3.35c-.64-.64-1.19-.93-1.14-1Z'
					className='animable'
					fill='#eb996e'
					transform-origin='462.513px 150.64px'
				/>
				<path
					d='m343 170.45-25 6.49s-20.62-22.94-21.59-23.75-13.65 3.23-13.65 3.23l14.73 27.27c3.51 8.89 8.74 13.91 13.82 14.13l41-8.14Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='317.535px 175.451px'
				/>
				<path
					d='M297.23 154.21s-2.85-5.73-3.25-6.59a78.75 78.75 0 0 1-2.48-7.62s-1.7-.38-1.59 3.43-.66 2.75-.66 2.75-7.9-9.6-9.82-9c-.71.24.27 2.52 1.58 3.75a26.52 26.52 0 0 1 2.72 3.23s-7.43-6.7-9.13-5.65c0 0-.83.66 1.53 2.63a53.7 53.7 0 0 1 5.5 5.31s-7.37-5.19-8.2-4.63c-1.39.93 6.08 6.23 7.32 8.2 0 0-5.55-4.26-5.7-2.89s6.76 6.17 9.92 13.14Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='285.244px 148.711px'
				/>
				<path
					d='M291.29 147.07c0 .07-.5.36-1.13 1.08a5.33 5.33 0 0 0-1.34 3.35v.65l-.45-.49a6.33 6.33 0 0 0-3.13-1.93c-.93-.26-1.55-.24-1.55-.33a2.86 2.86 0 0 1 1.63 0 6 6 0 0 1 3.45 1.95l-.46.17a5.11 5.11 0 0 1 1.6-3.59c.74-.74 1.37-.93 1.38-.86Z'
					className='animable'
					fill='#eb996e'
					transform-origin='287.49px 149.603px'
				/>
				<path
					d='M385.14 137.64a1.56 1.56 0 0 0 2.09 2c1-.46 1.25-1.87 1.11-3s-.45-2.36.08-3.38a7.57 7.57 0 0 1 1.86-1.84 4.92 4.92 0 0 0 1.6-4.12 4.15 4.15 0 0 0-2.68-3.43c-1.48-.5-3.35-.14-4.41-1.29-.77-.83-.75-2.12-1.33-3.1-.89-1.51-2.94-1.86-4.69-1.71s-3.55.6-5.23.08c-1.41-.43-2.52-1.48-3.82-2.17a7.7 7.7 0 0 0-10.58 10 4.85 4.85 0 0 0 2.26 2.48'
					className='animable'
					fill='#263238'
					transform-origin='375.179px 127.291px'
				/>
				<path
					d='m383.39 167.47-16.55-1.32c-.11-1.93 0-9.41 0-9.41s-6.89-1.07-7-8 1.16-22.67 1.16-22.67a23.94 23.94 0 0 1 24.05 3l1 .78Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='372.942px 145.794px'
				/>
				<path
					d='M363.8 137.76a1 1 0 0 0 .07-1.41 1 1 0 0 0-1.42-.07 1 1 0 0 0-.07 1.41 1 1 0 0 0 1.42.07Z'
					className='animable'
					fill='#263238'
					transform-origin='363.125px 137.02px'
				/>
				<path
					d='M360.92 136.5c.11.12.78-.4 1.73-.41s1.64.49 1.75.37-.06-.27-.36-.5a2.28 2.28 0 0 0-1.39-.44 2.33 2.33 0 0 0-1.38.47c-.27.24-.4.46-.35.51Z'
					className='animable'
					fill='#263238'
					transform-origin='362.672px 136.019px'
				/>
				<path
					d='M372.64 136.67a1 1 0 0 0-.33 1.37 1 1 0 1 0 1.7-1 1 1 0 0 0-1.37-.37Z'
					className='animable'
					fill='#263238'
					transform-origin='373.204px 137.609px'
				/>
				<path
					d='M371.23 137c.1.12.78-.4 1.73-.41s1.64.49 1.74.37-.06-.27-.36-.5A2.25 2.25 0 0 0 373 136a2.35 2.35 0 0 0-1.38.47c-.34.26-.45.53-.39.53Z'
					className='animable'
					fill='#263238'
					transform-origin='372.972px 136.509px'
				/>
				<path
					d='M367.42 145a4.72 4.72 0 0 0-1.53-.32c-.25 0-.45-.09-.46-.22a1.34 1.34 0 0 1 .17-.71c.25-.63.5-1.26.75-1.93a26 26 0 0 0 1.63-5.07 26.65 26.65 0 0 0-2.13 4.88c-.25.67-.48 1.31-.71 1.94a1.61 1.61 0 0 0-.14 1 .66.66 0 0 0 .43.39 1.76 1.76 0 0 0 .42.06 4.49 4.49 0 0 0 1.57-.02Z'
					className='animable'
					fill='#263238'
					transform-origin='366.477px 140.915px'
				/>
				<path
					d='M370.5 146.05a18 18 0 0 1-4.65 1.35 2.63 2.63 0 0 0 3.09 1c2.06-.71 1.56-2.35 1.56-2.35Z'
					className='animable'
					fill='#fff'
					transform-origin='368.202px 147.306px'
				/>
				<path
					d='M366.86 156.64a16.07 16.07 0 0 0 9-2.55s-2.12 4.95-9 4.33Z'
					className='animable'
					fill='#eb996e'
					transform-origin='371.36px 156.282px'
				/>
				<path
					d='M360.86 127.81s4 2.33 9.67 0c3.71-1.52 7.93-2.08 8.8-1.3s.78 4.48 4.24 5.82c0 0-.76 7 2.05 7s1.87-11 1.87-11l-6.59-3.85-7.37-2-7.11.47-5.56 1.05Z'
					className='animable'
					fill='#263238'
					transform-origin='374.25px 130.905px'
				/>
				<path
					d='M385.23 137c.12-.05 4.74-1.4 4.59 3.31s-4.85 3.58-4.86 3.45.27-6.76.27-6.76Z'
					className='animable'
					fill='#ffbe9d'
					transform-origin='387.392px 140.377px'
				/>
				<path
					d='M386.46 142s.08.06.22.13a.77.77 0 0 0 .61 0 2 2 0 0 0 1-1.79 2.64 2.64 0 0 0-.2-1.18.93.93 0 0 0-.59-.65.41.41 0 0 0-.49.21c-.07.13 0 .22-.07.23s-.1-.08-.05-.28a.49.49 0 0 1 .19-.28.64.64 0 0 1 .46-.11 1.15 1.15 0 0 1 .83.76 2.71 2.71 0 0 1 .24 1.32 2.11 2.11 0 0 1-1.26 2 .88.88 0 0 1-.74-.14c-.15-.06-.17-.17-.15-.22Z'
					className='animable'
					fill='#eb996e'
					transform-origin='387.535px 140.331px'
				/>
				<path
					d='M388.43 122.42c0 .15-.74.08-1.52.34s-1.33.69-1.44.59.33-.8 1.28-1.09 1.73.03 1.68.16Z'
					className='animable'
					fill='#263238'
					transform-origin='386.943px 122.753px'
				/>
				<path
					d='M385.75 119.45a3.21 3.21 0 0 1 .14 2.24c-.25 1.28-1.05 2-1.14 1.94s.41-.9.63-2 .21-2.17.37-2.18Z'
					className='animable'
					fill='#263238'
					transform-origin='385.384px 121.542px'
				/>
				<path
					d='M365.53 134.79c-.14.26-1 0-2.13 0s-2 .1-2.13-.17.82-.93 2.18-.87 2.24.81 2.08 1.04Z'
					className='animable'
					fill='#263238'
					transform-origin='363.403px 134.326px'
				/>
				<path
					d='M376.1 133.91c-.14.26-1 0-2.13 0s-2 .1-2.13-.17.81-.93 2.18-.87 2.24.8 2.08 1.04Z'
					className='animable'
					fill='#263238'
					transform-origin='373.973px 133.446px'
				/>
				<path
					d='m415.09 425 1.64 6.9s11.27 14.64 14.75 13.93c2.28-.47-.52-4.29-4.81-15.42l-.9-4.59Z'
					className='animable'
					fill='#f41760'
					transform-origin='423.692px 435.428px'
				/>
				<path
					d='M431.94 443.64a.59.59 0 0 1-.09.21 1.35 1.35 0 0 1-.47.44 1.89 1.89 0 0 1-1 .22 2.58 2.58 0 0 1-1.27-.47 53.13 53.13 0 0 1-5.68-5.3 70.88 70.88 0 0 1-5-5.9c-.6-.79-1.07-1.44-1.39-1.9l-.36-.53-.12-.19a.69.69 0 0 1 .15.17l.39.5c.42.54.9 1.15 1.44 1.86 1.24 1.55 3 3.66 5.08 5.85a62 62 0 0 0 5.61 5.32 2.1 2.1 0 0 0 2.16.3 1.4 1.4 0 0 0 .55-.58Z'
					className='animable'
					fill='#263238'
					transform-origin='424.25px 437.367px'
				/>
				<path
					d='M430.34 438.94a8.58 8.58 0 0 0-.91 0 5.22 5.22 0 0 0-2 .77 4.06 4.06 0 0 0-1.52 1.52c-.27.49-.34.84-.38.83a2 2 0 0 1 .24-.9 4 4 0 0 1 1.55-1.63 4.81 4.81 0 0 1 2.13-.74 1.76 1.76 0 0 1 .89.15Z'
					className='animable'
					fill='#263238'
					transform-origin='427.935px 440.421px'
				/>
				<path
					d='M419.67 435.5s.12-.5.21-1.29a5.37 5.37 0 0 0-.56-3 5.07 5.07 0 0 0-2.16-2.18 8.14 8.14 0 0 0-1.23-.44 1.23 1.23 0 0 1 .36 0 3.92 3.92 0 0 1 .93.29 4.87 4.87 0 0 1 2.28 2.22 5.13 5.13 0 0 1 .53 3.13 5.75 5.75 0 0 1-.23.95 1.31 1.31 0 0 1-.13.32Z'
					className='animable'
					fill='#263238'
					transform-origin='418.008px 432.038px'
				/>
				<path
					d='M415.8 426.15a7.12 7.12 0 0 1 .62 2.16c.21 1.23.43 2.19.39 2.21a7.06 7.06 0 0 1-.59-2.17c-.22-1.22-.47-2.18-.42-2.2Z'
					className='animable'
					fill='#263238'
					transform-origin='416.304px 428.335px'
				/>
				<path
					d='M426.87 431.36c0 .07-.64 0-1.4.22s-1.32.47-1.35.42a3.38 3.38 0 0 1 2.75-.64Z'
					className='animable'
					fill='#263238'
					transform-origin='425.495px 431.649px'
				/>
				<path
					d='M427.1 432.55c0 .06-.54 0-1.17.15s-1.08.44-1.12.39a1.79 1.79 0 0 1 1.07-.59 1.65 1.65 0 0 1 1.22.05Z'
					className='animable'
					fill='#263238'
					transform-origin='425.955px 432.751px'
				/>
				<path
					d='M428 434a5.25 5.25 0 0 0-1.21 0 5.06 5.06 0 0 0-1.12.49 1.49 1.49 0 0 1 1.07-.7 1.46 1.46 0 0 1 1.26.21Z'
					className='animable'
					fill='#263238'
					transform-origin='426.835px 434.11px'
				/>
				<path
					d='M426.09 430.87a1.29 1.29 0 0 1-.37-.05 6.73 6.73 0 0 1-1-.27 8.51 8.51 0 0 1-1.4-.62 8.21 8.21 0 0 1-.78-.48 1.18 1.18 0 0 1-.56-.86.67.67 0 0 1 .85-.54 1.81 1.81 0 0 1 .79.53 12.31 12.31 0 0 1 1 1.13 8.38 8.38 0 0 1 .62.82c.14.2.21.32.19.33s-.34-.41-.92-1.06c-.29-.32-.64-.69-1.06-1.08a1.61 1.61 0 0 0-.69-.47c-.26-.06-.6.08-.6.35s.24.51.47.68a7.85 7.85 0 0 0 .75.48 9.78 9.78 0 0 0 1.36.66c.83.31 1.36.42 1.35.45Z'
					className='animable'
					fill='#263238'
					transform-origin='424.035px 429.447px'
				/>
				<path
					d='M425.5 430.73a1.22 1.22 0 0 1 0-.35c0-.22 0-.54.07-.93a5 5 0 0 1 .36-1.36 2.79 2.79 0 0 1 .44-.73.77.77 0 0 1 .9-.28.87.87 0 0 1 .31.89 3.2 3.2 0 0 1-.25.81 4.28 4.28 0 0 1-.8 1.16 5.07 5.07 0 0 1-.72.61 1 1 0 0 1-.3.18s.39-.31.91-.89a4.39 4.39 0 0 0 .73-1.14 3.1 3.1 0 0 0 .22-.75.69.69 0 0 0-.2-.69c-.21-.12-.47.05-.65.24a3.34 3.34 0 0 0-.42.66 5.53 5.53 0 0 0-.38 1.31 11.42 11.42 0 0 1-.22 1.26Z'
					className='animable'
					fill='#263238'
					transform-origin='426.546px 428.881px'
				/>
				<g className='animable' opacity='.4'>
					<path
						d='m416.73 431.88-.8-3.32s2.77.51 3.48 2.58a8.63 8.63 0 0 1 .54 3.54l6 6.47s1.51-2.94 4.23-2.24c0 0 2.15 4.73 2.08 5.91s-1.44 1-1.93.82a24.52 24.52 0 0 1-5.38-4.25c-3.17-3.3-6.68-7.48-8.22-9.51Z'
						className='animable'
						transform-origin='424.096px 437.165px'
					/>
				</g>
				<path
					d='M359 428.47v-9.2l17.22-.21.22 13.45-1.07.09c-4.75.32-24.17 1.3-27.36.37-3.57-1.03 10.99-4.5 10.99-4.5Z'
					className='animable'
					fill='#f41760'
					transform-origin='361.943px 426.21px'
				/>
				<g className='animable' opacity='.4'>
					<path
						d='M370.17 432.45a6 6 0 0 1 2.16-3.69 5.85 5.85 0 0 1 4-1.31l.06 4.82Z'
						className='animable'
						transform-origin='373.28px 429.946px'
					/>
				</g>
				<g className='animable' opacity='.4'>
					<path
						d='M351.9 430.42s-5.11 1.54-4.46 2.38 20.32.58 29-.29v-.38l-22.94.49s-.59-2.17-1.6-2.2Z'
						className='animable'
						transform-origin='361.911px 431.866px'
					/>
				</g>
				<path
					d='M376.66 432.12h-.3l-.85.06-3.13.18c-2.64.13-6.29.26-10.33.31s-7.69 0-10.34 0l-3.13-.09h-1.15 14.62c4.04 0 7.68-.16 10.33-.25l3.13-.11h.85Z'
					className='animable'
					fill='#263238'
					transform-origin='362.045px 432.406px'
				/>
				<path
					d='M353.46 432.88a6.88 6.88 0 0 0-.6-1.48 7.8 7.8 0 0 0-1.08-1.19 2.35 2.35 0 0 1 1.25 1.08 2.29 2.29 0 0 1 .43 1.59Z'
					className='animable'
					fill='#263238'
					transform-origin='352.626px 431.545px'
				/>
				<path
					d='M358.51 430.24c-.05 0-.29-.26-.55-.65s-.43-.74-.38-.77.3.26.55.65.43.74.38.77Z'
					className='animable'
					fill='#263238'
					transform-origin='358.045px 429.529px'
				/>
				<path
					d='M359.9 429.49s-.32-.14-.62-.4-.51-.51-.47-.56.31.14.61.4.51.51.48.56Z'
					className='animable'
					fill='#263238'
					transform-origin='359.354px 429.006px'
				/>
				<path
					d='M360.76 427.85a2.11 2.11 0 0 1-.9.13 1.94 1.94 0 0 1-.9-.09 2.17 2.17 0 0 1 .89-.12 2.08 2.08 0 0 1 .91.08Z'
					className='animable'
					fill='#263238'
					transform-origin='359.86px 427.875px'
				/>
				<path
					d='M361 426.7a2.56 2.56 0 0 1-2 .18 5.54 5.54 0 0 1 1-.08 5.12 5.12 0 0 1 1-.1Z'
					className='animable'
					fill='#263238'
					transform-origin='360px 426.852px'
				/>
				<path
					d='M357.91 428.75a3.27 3.27 0 0 1-1.11 0 6 6 0 0 1-1.18-.24 3.69 3.69 0 0 1-.68-.27.61.61 0 0 1-.28-.34.45.45 0 0 1 .16-.45 2 2 0 0 1 2.52.57 1.92 1.92 0 0 1 .37.73c.05.19.05.3 0 .3a2.84 2.84 0 0 0-.51-.94 2 2 0 0 0-1-.6 1.69 1.69 0 0 0-1.32.11c-.18.13-.11.33.09.45a4.39 4.39 0 0 0 .63.26 9.84 9.84 0 0 0 1.14.28c.74.11 1.17.1 1.17.14Z'
					className='animable'
					fill='#263238'
					transform-origin='356.28px 428.137px'
				/>
				<path
					d='M357.62 428.81a1.17 1.17 0 0 1-.14-.77 1.76 1.76 0 0 1 .3-.81 1.1 1.1 0 0 1 .91-.58.44.44 0 0 1 .35.51 1.35 1.35 0 0 1-.18.49 3.65 3.65 0 0 1-.52.68 1.61 1.61 0 0 1-.63.46s.22-.21.52-.56a4.31 4.31 0 0 0 .46-.67c.15-.24.24-.66 0-.7s-.56.25-.73.48a1.82 1.82 0 0 0-.3.72 4.44 4.44 0 0 0-.04.75Z'
					className='animable'
					fill='#263238'
					transform-origin='358.256px 427.73px'
				/>
				<path
					d='M376.25 427.41s-.5 0-1.27.06a5.51 5.51 0 0 0-2.77 1.18 5.59 5.59 0 0 0-1.7 2.47c-.25.74-.27 1.24-.31 1.24a1.26 1.26 0 0 1 0-.35 4.92 4.92 0 0 1 .18-.93 5.24 5.24 0 0 1 4.59-3.76 4.78 4.78 0 0 1 1 0 1 1 0 0 1 .28.09Z'
					className='animable'
					fill='#263238'
					transform-origin='373.219px 429.827px'
				/>
				<path
					d='M374.37 420.26a27.8 27.8 0 0 1 .19 3.54 30 30 0 0 1 0 3.54 62.77 62.77 0 0 1-.18-7.08Z'
					className='animable'
					fill='#263238'
					transform-origin='374.481px 423.8px'
				/>
				<path
					d='M368 430.8a14.23 14.23 0 0 1-5 .11c0-.06 1.13 0 2.52 0s2.48-.17 2.48-.11Z'
					className='animable'
					fill='#263238'
					transform-origin='365.5px 430.933px'
				/>
				<path
					d='M371.36 430.75c0 .05-.09.24-.2.5s-.17.49-.23.49-.09-.27 0-.57.39-.46.43-.42Z'
					className='animable'
					fill='#263238'
					transform-origin='371.117px 431.242px'
				/>
				<path
					d='M372.61 429.16s-.06.22-.24.4-.35.3-.39.26.06-.22.24-.41.35-.29.39-.25Z'
					className='animable'
					fill='#263238'
					transform-origin='372.291px 429.489px'
				/>
				<path
					d='M374.42 428.41c0 .06-.24.06-.49.15s-.43.23-.48.19.1-.28.41-.39.58 0 .56.05Z'
					className='animable'
					fill='#263238'
					transform-origin='373.931px 428.535px'
				/>
				<path
					d='M375.72 428.05c0 .05-.08.14-.22.2s-.28.06-.3 0 .08-.14.22-.2.27-.05.3 0Z'
					className='animable'
					fill='#263238'
					transform-origin='375.459px 428.152px'
				/>
				<path
					className='animable'
					fill='#263238'
					transform-origin='390.345px 336.03px'
					d='m347.31 245.85 8.04 178.65 26.82.57-4.45-149.57 30.16 150.71h25.5l-34.05-180.36'
				/>
				<path
					className='animable'
					fill='#455a64'
					transform-origin='419.97px 424.715px'
					d='m406.56 423.78.61 2.64 26.21.36-.39-4.13-26.43 1.13z'
				/>
				<path
					d='M427 423.63c.15 0 .32.28.38.69s0 .76-.13.78-.31-.28-.38-.69-.05-.76.13-.78Z'
					className='animable'
					fill='#455a64'
					transform-origin='427.118px 424.365px'
				/>
				<path
					d='M426 417.78c.14 0 .37.61.5 1.42s.13 1.48 0 1.5-.36-.61-.5-1.42-.16-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='426.242px 419.24px'
				/>
				<path
					d='M425 411.93c.14 0 .37.61.5 1.42s.13 1.48 0 1.5-.37-.61-.5-1.42-.14-1.43 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='425.248px 413.39px'
				/>
				<path
					d='M424 406.08c.14 0 .36.61.5 1.42s.13 1.48 0 1.5-.37-.61-.51-1.42-.12-1.48.01-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='424.247px 407.54px'
				/>
				<path
					d='M423 400.23c.14 0 .37.61.5 1.42s.13 1.48 0 1.5-.36-.61-.5-1.42-.11-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='423.252px 401.69px'
				/>
				<path
					d='M422 394.38c.14 0 .37.61.51 1.42s.13 1.48 0 1.5-.37-.61-.51-1.42-.1-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='422.26px 395.84px'
				/>
				<path
					d='M421.05 388.53c.14 0 .37.61.51 1.41s.13 1.49 0 1.51-.37-.61-.51-1.42-.14-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='421.303px 389.99px'
				/>
				<path
					d='M420.06 382.68c.14 0 .37.61.5 1.42s.14 1.48 0 1.5-.37-.61-.51-1.42-.13-1.48.01-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='420.306px 384.14px'
				/>
				<path
					d='M419.06 376.83c.14 0 .37.61.51 1.42s.13 1.48 0 1.5-.37-.61-.51-1.42-.14-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='419.313px 378.29px'
				/>
				<path
					d='M418.06 371c.14 0 .37.61.51 1.42s.13 1.48 0 1.5-.37-.61-.5-1.42-.15-1.5-.01-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='418.317px 372.46px'
				/>
				<path
					d='M417.06 365.13c.14 0 .37.61.5 1.42s.14 1.48 0 1.5-.37-.61-.51-1.41-.13-1.48.01-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='417.306px 366.59px'
				/>
				<path
					d='M416.05 359.28c.14 0 .37.61.51 1.42s.13 1.48 0 1.51-.37-.61-.51-1.42-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='416.303px 360.746px'
				/>
				<path
					d='M415 353.44c.14 0 .37.61.51 1.41s.14 1.49 0 1.51-.37-.61-.51-1.42-.11-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='415.26px 354.9px'
				/>
				<path
					d='M414 347.59c.14 0 .37.61.51 1.42s.14 1.48 0 1.51-.37-.61-.51-1.42-.13-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='414.257px 349.056px'
				/>
				<path
					d='M413 341.75c.15 0 .38.61.52 1.41s.14 1.49 0 1.51-.37-.61-.52-1.42-.16-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='413.254px 343.21px'
				/>
				<path
					d='M412 335.91c.14 0 .37.6.52 1.41s.14 1.48 0 1.51-.37-.61-.52-1.42-.19-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='412.25px 337.371px'
				/>
				<path
					d='M410.91 330.06c.14 0 .37.61.52 1.42s.14 1.48 0 1.51-.37-.61-.52-1.42-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='411.17px 331.526px'
				/>
				<path
					d='M409.86 324.22c.14 0 .37.61.52 1.42s.15 1.48 0 1.5-.38-.6-.52-1.41-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='410.124px 325.68px'
				/>
				<path
					d='M408.8 318.39c.14 0 .38.6.52 1.41s.15 1.48 0 1.51-.37-.61-.52-1.42-.14-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='409.06px 319.851px'
				/>
				<path
					d='M407.74 312.55c.14 0 .37.61.52 1.41s.15 1.48 0 1.51-.37-.61-.52-1.41-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='408.002px 314.01px'
				/>
				<path
					d='M406.66 306.71c.14 0 .38.61.53 1.42s.15 1.48 0 1.5-.38-.6-.53-1.41-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='406.927px 308.17px'
				/>
				<path
					d='M405.58 300.88c.14 0 .37.61.52 1.41s.16 1.48 0 1.51-.38-.61-.53-1.41-.14-1.48.01-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='405.839px 302.341px'
				/>
				<path
					d='M404.48 295.05c.14 0 .38.6.53 1.41s.16 1.48 0 1.5-.38-.6-.53-1.41-.14-1.47 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='404.749px 296.505px'
				/>
				<path
					d='M403.37 289.22c.14 0 .38.6.54 1.41s.16 1.48 0 1.5-.38-.6-.53-1.4-.15-1.48-.01-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='403.648px 290.675px'
				/>
				<path
					d='M402.25 283.39c.15 0 .39.61.54 1.41s.17 1.48 0 1.51-.39-.61-.54-1.41-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='402.526px 284.851px'
				/>
				<path
					d='M401.12 277.57c.14 0 .39.6.54 1.4s.17 1.48 0 1.51-.38-.6-.54-1.41-.12-1.47 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='401.397px 279.026px'
				/>
				<path
					d='M400 271.75c.14 0 .38.6.54 1.4s.17 1.48 0 1.51-.38-.6-.54-1.41-.16-1.48 0-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='400.272px 273.206px'
				/>
				<path
					d='M398.82 265.93c.14 0 .39.6.55 1.4s.17 1.48 0 1.51-.38-.6-.54-1.41-.15-1.43-.01-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='399.103px 267.386px'
				/>
				<path
					d='M397.65 260.11c.14 0 .38.6.55 1.4s.18 1.48 0 1.51-.39-.6-.55-1.4-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='397.934px 261.566px'
				/>
				<path
					d='M396.46 254.29c.14 0 .39.6.55 1.41s.19 1.47 0 1.5-.38-.6-.55-1.4-.14-1.48 0-1.51Z'
					className='animable'
					fill='#455a64'
					transform-origin='396.742px 255.746px'
				/>
				<path
					d='M395.55 249.91c.14 0 .32.28.41.69s0 .75-.1.78-.33-.27-.41-.68-.04-.76.1-.79Z'
					className='animable'
					fill='#455a64'
					transform-origin='395.703px 250.646px'
				/>
				<path
					d='M377.55 423.61c.14 0 .27.32.3.73s-.08.76-.23.76-.27-.32-.3-.73.08-.76.23-.76Z'
					className='animable'
					fill='#455a64'
					transform-origin='377.585px 424.355px'
				/>
				<path
					d='M377.3 417.65c.14 0 .29.66.32 1.48s-.06 1.49-.21 1.5-.28-.65-.31-1.48.06-1.49.2-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='377.36px 419.14px'
				/>
				<path
					d='M377.12 411.7c.14 0 .28.66.3 1.48s-.07 1.49-.22 1.5-.28-.66-.3-1.48.1-1.49.22-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='377.16px 413.19px'
				/>
				<path
					d='M377 405.75c.15 0 .28.66.3 1.48s-.08 1.49-.22 1.49-.28-.66-.3-1.48.04-1.49.22-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='377.039px 407.235px'
				/>
				<path
					d='M376.82 399.79c.15 0 .28.66.3 1.48s-.08 1.5-.23 1.5-.27-.66-.29-1.48.08-1.5.22-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.86px 401.28px'
				/>
				<path
					d='M376.67 393.83c.14 0 .28.66.3 1.48s-.08 1.5-.22 1.5-.28-.66-.3-1.48.07-1.5.22-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.71px 395.32px'
				/>
				<path
					d='M376.47 387.87c.15 0 .29.66.31 1.48s-.06 1.5-.2 1.5-.29-.66-.32-1.48.07-1.49.21-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.519px 389.36px'
				/>
				<path
					d='M376.22 381.92c.15 0 .29.66.32 1.48s-.05 1.49-.19 1.5-.29-.66-.33-1.48.06-1.49.2-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.279px 383.41px'
				/>
				<path
					d='M376 376c.14 0 .28.66.32 1.48s-.06 1.49-.21 1.5-.28-.66-.31-1.48.05-1.5.2-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.061px 377.49px'
				/>
				<path
					d='M375.78 370c.15 0 .28.65.31 1.48s-.09 1.52-.21 1.52-.28-.65-.31-1.48.07-1.52.21-1.52Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.83px 371.5px'
				/>
				<path
					d='M375.6 364.06c.14 0 .28.66.3 1.48s-.07 1.49-.21 1.5-.28-.66-.31-1.49.08-1.49.22-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.639px 365.55px'
				/>
				<path
					d='M375.44 358.1c.15 0 .28.66.3 1.49s-.08 1.49-.22 1.49-.28-.66-.3-1.48.08-1.49.22-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.48px 359.59px'
				/>
				<path
					d='M375.32 352.15c.14 0 .27.66.29 1.48s-.09 1.49-.23 1.5-.28-.66-.29-1.49.08-1.49.23-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.351px 353.64px'
				/>
				<path
					d='M375.21 346.19c.15 0 .28.67.29 1.49s-.09 1.49-.24 1.49-.27-.66-.28-1.48.09-1.5.23-1.5Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.24px 347.68px'
				/>
				<path
					d='M375.14 340.24c.15 0 .27.66.28 1.48s-.1 1.49-.24 1.49-.27-.66-.28-1.48.1-1.49.24-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.16px 341.725px'
				/>
				<path
					d='M375.1 334.28c.14 0 .26.67.27 1.49s-.11 1.49-.25 1.49-.27-.67-.27-1.49.15-1.49.25-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.11px 335.77px'
				/>
				<path
					d='M375.09 328.32c.14 0 .26.67.26 1.49s-.12 1.49-.26 1.49-.26-.66-.26-1.49.11-1.49.26-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.09px 329.81px'
				/>
				<path
					d='M375.1 322.37c.15 0 .26.66.26 1.49s-.12 1.49-.27 1.49-.26-.67-.25-1.5.16-1.48.26-1.48Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.1px 323.86px'
				/>
				<path
					d='M375.15 316.41c.15 0 .26.67.25 1.49s-.13 1.49-.28 1.49-.25-.67-.24-1.49.12-1.49.27-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.14px 317.9px'
				/>
				<path
					d='M375.23 310.45c.14 0 .25.67.24 1.5s-.14 1.48-.28 1.48-.25-.67-.24-1.49.13-1.49.28-1.49Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.21px 311.94px'
				/>
				<path
					d='M375.33 304.5c.15 0 .25.67.24 1.49s-.15 1.49-.29 1.49-.25-.67-.23-1.5.14-1.48.28-1.48Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.309px 305.99px'
				/>
				<path
					d='M375.47 298.54c.14 0 .24.67.22 1.5s-.15 1.48-.29 1.48-.25-.67-.23-1.5.16-1.48.3-1.48Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.43px 300.03px'
				/>
				<path
					d='M375.68 292.58c.14 0 .23.68.2 1.5s-.18 1.49-.32 1.48-.23-.68-.2-1.5.18-1.48.32-1.48Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.62px 294.07px'
				/>
				<path
					d='M376 286.63c.14 0 .21.69.16 1.51s-.22 1.47-.36 1.47-.22-.69-.16-1.51.24-1.48.36-1.47Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.898px 288.12px'
				/>
				<path
					d='M376.57 280.7c.14 0 .19.69.11 1.51s-.27 1.47-.41 1.45-.19-.68-.11-1.5.27-1.48.41-1.46Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.42px 282.18px'
				/>
				<path
					d='M377.15 276.27c.14 0 .21.37.15.78s-.22.73-.36.71-.22-.37-.16-.78.22-.73.37-.71Z'
					className='animable'
					fill='#455a64'
					transform-origin='377.041px 277.015px'
				/>
				<path
					className='animable'
					fill='#455a64'
					transform-origin='368.83px 423.47px'
					d='m354.65 425.37 28.36.46-.22-4.72-28.14.15v4.11z'
				/>
				<path
					d='M373.25 248.12a5.39 5.39 0 0 1 .17 1.09c.07.71.16 1.73.27 3 .2 2.53.44 6 .68 9.88.12 1.92.22 3.75.32 5.44a16.74 16.74 0 0 0 .52 4.34A3.68 3.68 0 0 0 377 274a4.77 4.77 0 0 0 1 .29s-.1 0-.29.05a2.32 2.32 0 0 1-.82-.16 3.78 3.78 0 0 1-2.08-2.21 16.11 16.11 0 0 1-.65-4.44c-.11-1.69-.23-3.52-.36-5.44-.23-3.86-.42-7.35-.53-9.89a93.1 93.1 0 0 1-.1-3 3.93 3.93 0 0 1 .08-1.08Z'
					className='animable'
					fill='#455a64'
					transform-origin='375.581px 261.23px'
				/>
				<path
					d='M376 250.49c0 .07-.22.24-.25.67a.83.83 0 0 0 .21.61.72.72 0 0 0 1.14-.46.85.85 0 0 0-.28-.59c-.31-.28-.63-.22-.64-.3s.33-.3.85 0a1 1 0 0 1-.17 1.92 1.09 1.09 0 0 1-1.25-.26 1.11 1.11 0 0 1-.22-1c.16-.57.61-.66.61-.59Z'
					className='animable'
					fill='#455a64'
					transform-origin='376.516px 251.351px'
				/>
				<path
					d='M401.24 254.73a5.17 5.17 0 0 1-2.23.85 9.62 9.62 0 0 1-5.71-.64 9.49 9.49 0 0 1-4.28-3.83 5.13 5.13 0 0 1-.86-2.23c.09 0 .36.84 1.17 2a9.76 9.76 0 0 0 9.62 4.3c1.42-.18 2.26-.54 2.29-.45Z'
					className='animable'
					fill='#455a64'
					transform-origin='394.7px 252.318px'
				/>
				<path
					d='M356.64 248.12a3.89 3.89 0 0 1-.1 1.94 7.6 7.6 0 0 1-6.7 5.86 3.7 3.7 0 0 1-1.93-.16c0-.08.74 0 1.88-.2a8.32 8.32 0 0 0 4-1.88 8.44 8.44 0 0 0 2.39-3.72c.35-1.11.37-1.84.46-1.84Z'
					className='animable'
					fill='#455a64'
					transform-origin='352.314px 252.051px'
				/>
				<path
					d='M391.36 164.88a24.29 24.29 0 0 0-7.31-1.4 29.29 29.29 0 0 1-17.65 0 85.52 85.52 0 0 0-16 3l-22.4 6.04 7.33 27.48 13.52-4.56s-7.4 51.05-7.27 56.76l59.35-3.91-2.27-28.24-.75-24.51 17 3.12 11.42-22.79'
					className='animable'
					fill='#f41760'
					transform-origin='377.165px 207.84px'
				/>
				<path
					d='M386.39 163.39s-.24.22-.73.53a15.33 15.33 0 0 1-2.19 1.12 20.41 20.41 0 0 1-3.47 1.15 24.74 24.74 0 0 1-4.44.58 23.36 23.36 0 0 1-4.47-.33 20.5 20.5 0 0 1-3.53-.94 15.14 15.14 0 0 1-2.25-1 3.4 3.4 0 0 1-.77-.48c0-.08 1.18.51 3.13 1.13a23.92 23.92 0 0 0 3.5.82 26.18 26.18 0 0 0 4.37.28 27 27 0 0 0 4.35-.53 24.82 24.82 0 0 0 3.44-1c1.92-.72 3.02-1.41 3.06-1.33Z'
					className='animable'
					fill='#263238'
					transform-origin='375.465px 165.08px'
				/>
				<path
					d='M377.82 188.78a4.63 4.63 0 0 1 .92-.05l2.7-.06 9.77-.12h.23v9.35a6.93 6.93 0 0 1-5.4 6.29 6.91 6.91 0 0 1-7.87-4 7.16 7.16 0 0 1-.51-2 17.07 17.07 0 0 1 0-1.88c0-2.3.07-4.18.1-5.58v-1.48a3.12 3.12 0 0 1 0-.49 3.3 3.3 0 0 1 0 .56v1.53c0 1.37.06 3.23.1 5.5 0 .57 0 1.18.07 1.79a6.64 6.64 0 0 0 .51 1.85 6.5 6.5 0 0 0 7.36 3.69 6.45 6.45 0 0 0 5-5.83c.05-1.06 0-2.16 0-3.2v-5.89l.22.23-9.62-.12-2.76-.06a8.78 8.78 0 0 1-.82-.03Z'
					className='animable'
					fill='#263238'
					transform-origin='384.537px 196.455px'
				/>
				<path
					d='M390.78 190.9s.14-.06.41-.08v.18c-.91.1-3.45.17-6.45.17a44.39 44.39 0 0 1-6.85-.26 46 46 0 0 1 6.85-.26c3 0 5.54.08 6.45.18v.17c-.27 0-.41-.07-.41-.1Z'
					className='animable'
					fill='#263238'
					transform-origin='384.54px 190.912px'
				/>
				<path
					d='M424.74 175.5a3.85 3.85 0 0 1-.42.93l-1.32 2.43-4.28 8-4.19 8.06-1.27 2.44a3.69 3.69 0 0 1-.53.86 4 4 0 0 1 .34-.95c.26-.6.64-1.46 1.13-2.52 1-2.11 2.4-5 4.06-8.14s3.24-5.94 4.42-7.94c.59-1 1.09-1.81 1.44-2.35a4.24 4.24 0 0 1 .62-.82Z'
					className='animable'
					fill='#263238'
					transform-origin='418.735px 186.86px'
				/>
				<path
					d='M339 198.56a4.36 4.36 0 0 1-.47-1c-.28-.65-.66-1.6-1.11-2.77-.91-2.36-2.1-5.64-3.32-9.29s-2.23-7-2.91-9.43c-.35-1.21-.61-2.2-.78-2.88a4.08 4.08 0 0 1-.21-1.08 4.33 4.33 0 0 1 .4 1l.94 2.84c.82 2.51 1.88 5.77 3.06 9.36l3.16 9.33c.38 1.11.7 2.06 1 2.83a4.24 4.24 0 0 1 .24 1.09Z'
					className='animable'
					fill='#263238'
					transform-origin='334.6px 185.335px'
				/>
				<path
					d='M401.24 245.74c0 .14-13.21 1-29.52 2s-29.55 1.63-29.56 1.49 13.21-1.05 29.53-2 29.54-1.63 29.55-1.49Z'
					className='animable'
					fill='#263238'
					transform-origin='371.7px 247.486px'
				/>
			</g>
			<g id='character-1' className='animable'>
				<path
					d='m228 165 18.16-1.76c.23-2.05-.13-12-.13-12s7.4-.7 7.93-8 .27-24.23.27-24.23a25.52 25.52 0 0 0-25.79 1.68l-1.14.77Z'
					className='animable'
					fill='#b78876'
					transform-origin='240.797px 140.645px'
				/>
				<path
					d='M250 131.38a1.07 1.07 0 1 1 1.53-1.49 1.07 1.07 0 0 1-1.53 1.49Z'
					className='animable'
					fill='#263238'
					transform-origin='250.717px 130.586px'
				/>
				<path
					d='M253.43 129.87c-.12.12-.8-.47-1.81-.54s-1.78.41-1.88.28.08-.29.41-.51a2.49 2.49 0 0 1 2.95.21c.3.27.39.51.33.56Z'
					className='animable'
					fill='#263238'
					transform-origin='251.58px 129.3px'
				/>
				<path
					d='M240.88 130.1a1.07 1.07 0 1 1-1.49.26 1.08 1.08 0 0 1 1.49-.26Z'
					className='animable'
					fill='#263238'
					transform-origin='240.265px 130.978px'
				/>
				<path
					d='M242.69 130.15c-.13.12-.81-.48-1.82-.54s-1.78.41-1.88.27.08-.28.41-.5a2.49 2.49 0 0 1 2.95.21c.3.27.4.51.34.56Z'
					className='animable'
					fill='#263238'
					transform-origin='240.835px 129.58px'
				/>
				<path
					d='M246.23 138.72a5.28 5.28 0 0 1 1.66-.23c.26 0 .48-.06.51-.21a1.38 1.38 0 0 0-.14-.78l-.67-2.1a30 30 0 0 1-1.42-5.49 30.36 30.36 0 0 1 1.94 5.33c.22.73.43 1.43.63 2.11a1.69 1.69 0 0 1 .08 1.1.69.69 0 0 1-.47.39 1.87 1.87 0 0 1-.45 0 5 5 0 0 1-1.67-.12Z'
					className='animable'
					fill='#263238'
					transform-origin='247.523px 134.387px'
				/>
				<path
					d='M246.09 151.14a17.08 17.08 0 0 1-9.4-3.29s1.94 5.41 9.3 5.19Z'
					className='animable'
					fill='#a36957'
					transform-origin='241.39px 150.448px'
				/>
				<path
					d='M228.76 127.94c-.16-.06-5.44-.74-4.93 5.49s6.64 3.66 6.63 3.48-1.7-8.97-1.7-8.97Z'
					className='animable'
					fill='#b78876'
					transform-origin='227.128px 132.738px'
				/>
				<path
					d='M228.37 134.88s-.1.09-.28.19a1.14 1.14 0 0 1-.81.08 2.73 2.73 0 0 1-1.44-2.31 3.69 3.69 0 0 1 .18-1.58 1.26 1.26 0 0 1 .75-.9.57.57 0 0 1 .67.25c.09.16.06.29.1.3s.12-.12.05-.37a.67.67 0 0 0-.28-.37.82.82 0 0 0-.61-.11 1.51 1.51 0 0 0-1 1.06 3.66 3.66 0 0 0-.24 1.77 2.83 2.83 0 0 0 1.8 2.56 1.13 1.13 0 0 0 1-.25c.11-.2.14-.31.11-.32Z'
					className='animable'
					fill='#a36957'
					transform-origin='226.909px 132.761px'
				/>
				<path
					d='M235.71 115s.93-5.15 12.43-4.43a7.32 7.32 0 0 1 6.66 5.76 2.42 2.42 0 0 1 2.63 2.14 3.6 3.6 0 0 1-1.65 3.21 8.38 8.38 0 0 1-3.6 1c-7.73 1.14-13.12-3.32-17.09-3.72s-2.59 3.12-2.59 3.12c1.22 6.61-1.16 8.31-3.06 12.08h-1l-.9-5.25a4 4 0 0 1-.73-1.52c-.6-1.94-.77-4-1.44-5.9-1.58-4.45 1.51-6.65 1.51-6.65s1.47-2.47 8.83.16Z'
					className='animable'
					fill='#263238'
					transform-origin='241.177px 122.33px'
				/>
				<path
					d='M246.52 140.88c0 .05-.11.28-.49.47a2.09 2.09 0 0 1-1.65.05 2.13 2.13 0 0 1-1.17-1.16c-.15-.4-.1-.67 0-.68s.38 1 1.39 1.36 1.85-.16 1.92-.04Z'
					className='animable'
					fill='#263238'
					transform-origin='244.818px 140.553px'
				/>
				<path
					d='M241.58 126.1c-.07.14-.79-.11-1.69 0s-1.58.41-1.67.29.57-.73 1.63-.81 1.81.42 1.73.52Z'
					className='animable'
					fill='#263238'
					transform-origin='239.899px 125.995px'
				/>
				<path
					d='M252 126.05c-.07.13-.73-.12-1.55-.21s-1.52 0-1.57-.14.67-.48 1.62-.37 1.57.6 1.5.72Z'
					className='animable'
					fill='#263238'
					transform-origin='250.441px 125.698px'
				/>
				<path
					d='M236.48 110.66c0 .07-.32.06-.7.31a1.81 1.81 0 0 0-.7 1.51 3.31 3.31 0 0 0 .47 1.73c.24.41.46.63.42.69s-.36-.07-.72-.48a2.91 2.91 0 0 1-.7-2 2 2 0 0 1 1.06-1.81c.54-.19.9-.01.87.05Z'
					className='animable'
					fill='#263238'
					transform-origin='235.515px 112.72px'
				/>
				<path
					d='M238.78 429.34v-9.23l-17.29-.18-.2 13.5 1.07.09c4.77.31 24.27 1.26 27.47.33 3.61-1.04-11.05-4.51-11.05-4.51Z'
					className='animable'
					fill='#f41760'
					transform-origin='235.846px 427.089px'
				/>
				<g className='animable' opacity='.4'>
					<path
						d='M227.6 433.37a6 6 0 0 0-2.17-3.71 5.72 5.72 0 0 0-4-1.3l-.06 4.83Z'
						className='animable'
						transform-origin='224.485px 430.859px'
					/>
				</g>
				<path
					d='M245.94 431.29s5.14 1.54 4.49 2.38-20.4.62-29.1-.24v-.38l23 .45s.61-2.18 1.61-2.21Z'
					className='animable'
					opacity='.4'
					transform-origin='235.908px 432.745px'
				/>
				<path
					d='M221.09 433h.3l.85.06 3.14.17c2.66.13 6.32.25 10.38.3s7.72 0 10.38-.05l3.14-.1h1.15a.94.94 0 0 0-.29 0h-14.38c-4.05 0-7.72-.15-10.37-.24l-3.15-.1h-.85a1.36 1.36 0 0 0-.3-.04Z'
					className='animable'
					fill='#263238'
					transform-origin='235.76px 433.275px'
				/>
				<path
					d='M244.38 433.77a4.64 4.64 0 0 1 1.69-2.68 2.24 2.24 0 0 0-1.26 1.08 2.3 2.3 0 0 0-.43 1.6Z'
					className='animable'
					fill='#263238'
					transform-origin='245.219px 432.43px'
				/>
				<path
					d='M239.31 431.13c.05 0 .29-.27.55-.66s.43-.74.38-.77-.3.26-.55.65-.43.74-.38.78Z'
					className='animable'
					fill='#263238'
					transform-origin='239.775px 430.414px'
				/>
				<path
					d='M237.92 430.37s.31-.14.61-.4.51-.51.48-.56-.32.14-.62.4-.51.52-.47.56Z'
					className='animable'
					fill='#263238'
					transform-origin='238.464px 429.886px'
				/>
				<path
					d='M237.05 428.73a2 2 0 0 0 .9.12 2.08 2.08 0 0 0 .91-.08 3.78 3.78 0 0 0-1.81 0Z'
					className='animable'
					fill='#263238'
					transform-origin='237.955px 428.764px'
				/>
				<path
					d='M236.76 427.57a1.76 1.76 0 0 0 1 .31 1.79 1.79 0 0 0 1-.13 5.54 5.54 0 0 0-1-.08 6.29 6.29 0 0 0-1-.1Z'
					className='animable'
					fill='#263238'
					transform-origin='237.76px 427.736px'
				/>
				<path
					d='M239.91 429.62a3.09 3.09 0 0 0 1.11 0 6.2 6.2 0 0 0 1.19-.25 3.1 3.1 0 0 0 .68-.27.61.61 0 0 0 .28-.34.44.44 0 0 0-.16-.45 2 2 0 0 0-2.53.57 2 2 0 0 0-.37.74c-.05.19-.05.3 0 .3a2.93 2.93 0 0 1 .51-.95 2.09 2.09 0 0 1 1-.6 1.73 1.73 0 0 1 1.32.1c.18.14.11.34-.09.46a4.39 4.39 0 0 1-.63.26 6.8 6.8 0 0 1-1.15.28c-.73.12-1.16.12-1.16.15Z'
					className='animable'
					fill='#263238'
					transform-origin='241.546px 429px'
				/>
				<path
					d='M240.2 429.68a1.1 1.1 0 0 0 .14-.77 1.8 1.8 0 0 0-.3-.81 1.12 1.12 0 0 0-.92-.58.46.46 0 0 0-.35.51 1.3 1.3 0 0 0 .19.5 3.19 3.19 0 0 0 .52.68 1.51 1.51 0 0 0 .63.45s-.22-.2-.53-.55a3.82 3.82 0 0 1-.45-.68c-.15-.23-.25-.66 0-.7s.56.25.72.48a1.71 1.71 0 0 1 .31.72 4.41 4.41 0 0 1 .04.75Z'
					className='animable'
					fill='#263238'
					transform-origin='239.562px 428.6px'
				/>
				<path
					d='M221.5 428.31s.49 0 1.27.06a5.5 5.5 0 0 1 2.78 1.18 5.59 5.59 0 0 1 1.71 2.48c.26.74.28 1.24.32 1.24a1.07 1.07 0 0 0 0-.35 3.86 3.86 0 0 0-.18-.94 5.33 5.33 0 0 0-1.72-2.6 5.4 5.4 0 0 0-2.89-1.16 4.78 4.78 0 0 0-.95 0 .86.86 0 0 0-.34.09Z'
					className='animable'
					fill='#263238'
					transform-origin='224.547px 430.733px'
				/>
				<path
					d='M223.37 421.13a30.49 30.49 0 0 0-.19 3.55 29 29 0 0 0 0 3.56 30.49 30.49 0 0 0 .19-3.55 28.92 28.92 0 0 0 0-3.56Z'
					className='animable'
					fill='#263238'
					transform-origin='223.275px 424.685px'
				/>
				<path
					d='M229.8 431.7a9.07 9.07 0 0 0 2.52.28 10.23 10.23 0 0 0 2.53-.17c0-.06-1.14 0-2.53 0s-2.52-.17-2.52-.11Z'
					className='animable'
					fill='#263238'
					transform-origin='232.325px 431.842px'
				/>
				<path
					d='M226.41 431.66s.09.24.2.5.17.49.23.49.09-.27 0-.57-.39-.46-.43-.42Z'
					className='animable'
					fill='#263238'
					transform-origin='226.653px 432.152px'
				/>
				<path
					d='M225.15 430.06s.07.22.24.4.36.3.4.26-.07-.22-.25-.4-.35-.32-.39-.26Z'
					className='animable'
					fill='#263238'
					transform-origin='225.474px 430.387px'
				/>
				<path
					d='M223.33 429.31c0 .06.24.06.49.15s.44.23.48.19-.09-.28-.41-.39-.58 0-.56.05Z'
					className='animable'
					fill='#263238'
					transform-origin='223.818px 429.435px'
				/>
				<path
					d='M222 429c0 .06.08.15.22.2s.28.06.3 0-.08-.14-.22-.2-.25-.1-.3 0Z'
					className='animable'
					fill='#263238'
					transform-origin='222.261px 429.09px'
				/>
				<path
					d='m256.91 426.31 2.3-8.94L242.5 413l-3.5 13 1 .34c4.55 1.48 23.22 7.19 26.55 7.08 3.71-.15-9.64-7.11-9.64-7.11Z'
					className='animable'
					fill='#f41760'
					transform-origin='253.101px 423.211px'
				/>
				<g className='animable' opacity='.4'>
					<path
						d='M245.08 427.46a6 6 0 0 0-1.19-4.13 5.84 5.84 0 0 0-3.59-2.25l-1.24 4.67Z'
						className='animable'
						transform-origin='242.081px 424.27px'
					/>
				</g>
				<path
					d='M263.37 430s4.6 2.76 3.76 3.41S247.21 429 239 426l.13-.37 22.21 6.1s1.04-1.99 2.03-1.73Z'
					className='animable'
					opacity='.4'
					transform-origin='253.116px 429.549px'
				/>
				<path
					d='M238.85 425.54a1 1 0 0 0 .28.11l.81.27 3 .94c2.54.77 6.07 1.79 10 2.83s7.48 1.91 10.07 2.51l3.07.68.84.17a1 1 0 0 0 .3 0l-.29-.08-.83-.21-3-.75c-2.58-.63-6.14-1.52-10.06-2.56s-7.44-2-10-2.78l-3-.87-.82-.23a1.62 1.62 0 0 0-.37-.03Z'
					className='animable'
					fill='#263238'
					transform-origin='253.035px 429.3px'
				/>
				<path
					d='M261.25 432a6.46 6.46 0 0 1 .95-1.3 7.17 7.17 0 0 1 1.34-.89 2.33 2.33 0 0 0-1.49.74 2.31 2.31 0 0 0-.8 1.45Z'
					className='animable'
					fill='#263238'
					transform-origin='262.395px 430.905px'
				/>
				<path
					d='M257 428.17s.35-.18.69-.5.6-.62.56-.66-.35.18-.7.5-.61.62-.55.66Z'
					className='animable'
					fill='#263238'
					transform-origin='257.623px 427.588px'
				/>
				<path
					d='M255.81 427.09c0 .06.34 0 .7-.23s.62-.37.6-.43-.34.06-.7.24-.62.33-.6.42Z'
					className='animable'
					fill='#263238'
					transform-origin='256.46px 426.763px'
				/>
				<path
					d='M255.38 425.29a2 2 0 0 0 .84.34 1.86 1.86 0 0 0 .9.14 2.12 2.12 0 0 0-.84-.34 2 2 0 0 0-.9-.14Z'
					className='animable'
					fill='#263238'
					transform-origin='256.25px 425.531px'
				/>
				<path
					d='M255.38 424.1a1.78 1.78 0 0 0 .9.54 1.74 1.74 0 0 0 1 .13 6.69 6.69 0 0 0-1-.33 5.74 5.74 0 0 0-.9-.34Z'
					className='animable'
					fill='#263238'
					transform-origin='256.33px 424.447px'
				/>
				<path
					d='M257.93 426.86a3.32 3.32 0 0 0 1.08.28 6.51 6.51 0 0 0 1.21.05 3.83 3.83 0 0 0 .72-.09.67.67 0 0 0 .36-.27.42.42 0 0 0-.05-.47 2 2 0 0 0-2.59-.07 1.91 1.91 0 0 0-.54.62c-.09.17-.12.28-.1.29a2.81 2.81 0 0 1 .73-.79 2 2 0 0 1 1.07-.35 1.71 1.71 0 0 1 1.26.42c.14.18 0 .36-.2.42a3.1 3.1 0 0 1-.67.1 7.72 7.72 0 0 1-1.19 0c-.67-.06-1.08-.17-1.09-.14Z'
					className='animable'
					fill='#263238'
					transform-origin='259.64px 426.524px'
				/>
				<path
					d='M258.2 427a1.16 1.16 0 0 0 .32-.71 2 2 0 0 0-.09-.87 1.08 1.08 0 0 0-.75-.78.44.44 0 0 0-.46.41 1.1 1.1 0 0 0 .06.52 3.24 3.24 0 0 0 .33.79 1.66 1.66 0 0 0 .5.6s-.16-.25-.37-.67a4.5 4.5 0 0 1-.28-.77c-.08-.26-.08-.7.21-.67s.47.38.58.64a1.73 1.73 0 0 1 .12.78 4.76 4.76 0 0 1-.17.73Z'
					className='animable'
					fill='#263238'
					transform-origin='257.873px 425.82px'
				/>
				<path
					d='M240.4 421.06s.5.08 1.23.37a5.43 5.43 0 0 1 3.45 4.65c.06.79 0 1.27 0 1.28a1.19 1.19 0 0 0 .09-.34 4.79 4.79 0 0 0 .06-.95 5.36 5.36 0 0 0-1-2.94 5.3 5.3 0 0 0-2.51-1.84 4.78 4.78 0 0 0-.93-.22 1 1 0 0 0-.39-.01Z'
					className='animable'
					fill='#263238'
					transform-origin='242.817px 424.203px'
				/>
				<path
					d='M244 414.56a34.36 34.36 0 0 0-1 3.4 31.69 31.69 0 0 0-.86 3.45 30.1 30.1 0 0 0 1.06-3.4 27.84 27.84 0 0 0 .8-3.45Z'
					className='animable'
					fill='#263238'
					transform-origin='243.07px 417.985px'
				/>
				<path
					d='M247.62 426.39a9.57 9.57 0 0 0 2.37.89 9.23 9.23 0 0 0 2.5.45c0-.06-1.1-.28-2.44-.65s-2.41-.75-2.43-.69Z'
					className='animable'
					fill='#263238'
					transform-origin='250.055px 427.057px'
				/>
				<path
					d='M244.34 425.52c-.05 0 0 .25.07.53s.05.52.11.53.16-.24.1-.56-.23-.53-.28-.5Z'
					className='animable'
					fill='#263238'
					transform-origin='244.479px 426.049px'
				/>
				<path
					d='M243.51 423.65s0 .23.14.45.27.38.32.35 0-.23-.14-.45-.27-.38-.32-.35Z'
					className='animable'
					fill='#263238'
					transform-origin='243.749px 424.05px'
				/>
				<path
					d='M241.93 422.48c0 .06.22.12.45.27s.36.33.41.3 0-.29-.3-.48-.56-.15-.56-.09Z'
					className='animable'
					fill='#263238'
					transform-origin='242.368px 422.742px'
				/>
				<path
					d='M240.76 421.82s0 .15.17.24.25.13.28.08 0-.15-.16-.24-.25-.13-.29-.08Z'
					className='animable'
					fill='#263238'
					transform-origin='240.99px 421.98px'
				/>
				<path
					d='M265.66 240.08a75.12 75.12 0 0 0-7.07 5.73c-2.12 1.94 2.07 13.45 4.37 11.42s8.59-10 8.59-10Z'
					className='animable'
					fill='#b78876'
					transform-origin='264.779px 248.775px'
				/>
				<path
					d='M262.63 257.43s6.54-.74 6.35-2.09a7.23 7.23 0 0 0-1.62-3Z'
					className='animable'
					fill='#a36957'
					transform-origin='265.807px 254.885px'
				/>
				<path
					d='m265.21 250.11-20.35-1.53-33.47-2.66 4 179.73 29.05-.42s0-2-.07-5.51l17 4.63s16.52-56.09 22.14-79.12c4.74-19.23-18.3-95.12-18.3-95.12ZM244 391.77c-.51-41.48-1.12-112-.53-120.66 0 0 16.27 62.08 16.44 67 .09 2.96-8.84 31.64-15.91 53.66Z'
					className='animable'
					fill='#263238'
					transform-origin='247.771px 335.785px'
				/>
				<path
					d='M244.61 418.4c0 .16-6.5.3-14.51.31s-14.52-.11-14.52-.26 6.5-.3 14.51-.31 14.52.1 14.52.26Z'
					className='animable'
					fill='#455a64'
					transform-origin='230.095px 418.425px'
				/>
				<path
					d='M244.35 411.94a17 17 0 0 1 2.66.85l6.65 2.31 6.65 2.31a15.82 15.82 0 0 1 2.73 1.07 14.2 14.2 0 0 1-2.85-.68c-1.74-.5-4.12-1.25-6.72-2.16s-4.93-1.79-6.61-2.47a10 10 0 0 1-2.51-1.23Z'
					className='animable'
					fill='#455a64'
					transform-origin='253.695px 415.21px'
				/>
				<path
					d='M243.93 388.14a6.58 6.58 0 0 1 .09 1.41c0 1 0 2.29.06 3.83 0 3.33.13 7.75.2 12.64s.27 9.3.37 12.63c0 1.54.08 2.83.11 3.83a8.09 8.09 0 0 1 0 1.41 6.7 6.7 0 0 1-.18-1.4c-.08-.9-.18-2.21-.28-3.82-.2-3.23-.4-7.7-.51-12.64s-.11-9.41-.06-12.65c0-1.62.07-2.93.11-3.84a7.2 7.2 0 0 1 .09-1.4Z'
					className='animable'
					fill='#455a64'
					transform-origin='244.244px 406.015px'
				/>
				<path
					d='M270.41 337.54a27.55 27.55 0 0 1-5.47.7 26.21 26.21 0 0 1-5.52.14 26.3 26.3 0 0 1 5.48-.71 26.46 26.46 0 0 1 5.51-.13Z'
					className='animable'
					fill='#455a64'
					transform-origin='264.915px 337.959px'
				/>
				<path
					d='M268.53 340.8a16 16 0 0 1-4.2-.91 16.2 16.2 0 0 1-4-1.45 15.8 15.8 0 0 1 4.19.9 16.35 16.35 0 0 1 4.01 1.46Z'
					className='animable'
					fill='#455a64'
					transform-origin='264.43px 339.62px'
				/>
				<path
					d='M245.26 248.8a24 24 0 0 1 .16 3.43v8.26c0 1.61 0 3.14-.06 4.55a9.07 9.07 0 0 1-.68 3.71 4.92 4.92 0 0 1-1.63 2 2 2 0 0 1-.85.4 9.1 9.1 0 0 1 .73-.56 5.05 5.05 0 0 0 1.41-1.95 9 9 0 0 0 .54-3.57v-4.54c0-3.23.07-6.15.13-8.27a22.17 22.17 0 0 1 .25-3.46Z'
					className='animable'
					fill='#455a64'
					transform-origin='243.814px 259.975px'
				/>
				<path
					d='m269.48 172.37 22.16 24.89c6.51 7.87 5.26 18.35.1 27.17a156.37 156.37 0 0 1-19 25.11c-.1.14-8.95-12.38-8.95-12.38s13.69-21.91 11.49-26.92-17-23.26-17-23.26Z'
					className='animable'
					fill='#455a64'
					transform-origin='277.178px 210.956px'
				/>
				<path
					d='m262.81 192.62.65 33.71 2.62 24-55.55-3.45 2.91-28-2.84-29.5-15.43-13q1.59-2.13 3.08-3.93c6.89-8.29 18.74-13.47 29.51-13.85 0 0 2.35 3.85 11.27 4 6.24.12 7.42-4.06 7.42-4.06 4.15.26 15.57 2.21 24.43 15.38'
					className='animable'
					fill='#455a64'
					transform-origin='233.025px 204.435px'
				/>
				<path
					d='m200.23 170.73-22.08 25c-6.49 7.9-5.21 18.36 0 27.17 7.89 13.4 22.51 28.83 22.38 28.71s9.19-11.61 9.19-11.61-17.4-26.37-15.21-31.38 18.38-21.39 18.38-21.39Z'
					className='animable'
					fill='#455a64'
					transform-origin='193.32px 211.17px'
				/>
				<path
					d='M267.75 170.76a2.47 2.47 0 0 1-.35.59 7.81 7.81 0 0 1-1.37 1.42 11 11 0 0 1-6.82 2.19 20.08 20.08 0 0 1-5-.72c-1.75-.45-3.56-1.09-5.46-1.74a33.51 33.51 0 0 0-6-1.57 16 16 0 0 0-6.6.49c-4.41 1.22-8.41 3.46-12.56 3.69a12.79 12.79 0 0 1-3-.17 12 12 0 0 1-2.68-.88 24.1 24.1 0 0 1-4.27-2.62 45.31 45.31 0 0 0-5.92-4c-1.51-.77-2.44-1-2.42-1a3.16 3.16 0 0 1 .67.16 11.2 11.2 0 0 1 1.84.7 40.51 40.51 0 0 1 6.05 3.93 24.37 24.37 0 0 0 4.23 2.52 12.54 12.54 0 0 0 2.58.82 11.85 11.85 0 0 0 2.87.14c4-.24 7.95-2.46 12.46-3.71a16.27 16.27 0 0 1 6.8-.5 33.22 33.22 0 0 1 6.14 1.63c1.9.66 3.69 1.31 5.41 1.77a20.05 20.05 0 0 0 4.85.77 11.09 11.09 0 0 0 6.7-2 10.53 10.53 0 0 0 1.85-1.91Z'
					className='animable'
					fill='#263238'
					transform-origin='236.525px 170.787px'
				/>
				<path
					d='m280.57 184.5-.24-.07-.66-.25a20.39 20.39 0 0 0-2.63-.76 20.72 20.72 0 0 0-9.91.2 19.12 19.12 0 0 0-3.11 1.12c-1 .48-2.09 1.08-3.19 1.69a22.65 22.65 0 0 1-3.54 1.67 11 11 0 0 1-2 .49 9.58 9.58 0 0 1-2.14 0c-2.9-.36-5.49-2-8.3-3.11a12.06 12.06 0 0 0-4.45-.94 15.63 15.63 0 0 0-4.64.82c-3.07 1-5.93 2.44-9 3.12a15.35 15.35 0 0 1-8.82-.72 44.2 44.2 0 0 1-7.19-3.57 54.73 54.73 0 0 0-6.15-3.19 15.61 15.61 0 0 0-9.76-1.2 12 12 0 0 0-3.36 1.45l.19-.16a6 6 0 0 1 .59-.41 9 9 0 0 1 2.54-1.07 13.08 13.08 0 0 1 4.34-.36 18.26 18.26 0 0 1 5.6 1.41 52.48 52.48 0 0 1 6.22 3.18 45.13 45.13 0 0 0 7.14 3.49 15 15 0 0 0 8.55.67c3-.66 5.81-2.11 8.93-3.11a15.53 15.53 0 0 1 4.8-.84 12.27 12.27 0 0 1 4.64 1c2.86 1.14 5.42 2.75 8.17 3.1a8.54 8.54 0 0 0 2 0 9.51 9.51 0 0 0 1.93-.45 23.07 23.07 0 0 0 3.48-1.62c1.1-.59 2.16-1.2 3.23-1.67a19.53 19.53 0 0 1 3.18-1.12 20.57 20.57 0 0 1 10.06 0 14.09 14.09 0 0 1 3.5 1.21Z'
					className='animable'
					fill='#263238'
					transform-origin='236.025px 184.012px'
				/>
				<path
					d='M263.09 204.1a2.13 2.13 0 0 1-.43.34 4.33 4.33 0 0 1-1.48.59 8.59 8.59 0 0 1-5.66-1c-1.11-.54-2.26-1.24-3.53-1.86a15.73 15.73 0 0 0-4.29-1.35 28.67 28.67 0 0 0-10.33.56c-3.63.75-7.07 1.71-10.29 2.13a22.14 22.14 0 0 1-8.59-.3 13.54 13.54 0 0 1-5.23-2.48 8.07 8.07 0 0 1-1.16-1.08 2.21 2.21 0 0 1-.35-.43s.54.55 1.63 1.35a14.14 14.14 0 0 0 5.2 2.29 22.5 22.5 0 0 0 8.42.14c3.18-.45 6.6-1.41 10.26-2.17a28.44 28.44 0 0 1 10.51-.52 16 16 0 0 1 4.4 1.43c1.29.66 2.42 1.37 3.5 1.92a8.66 8.66 0 0 0 5.46 1.17 6.43 6.43 0 0 0 1.96-.73Z'
					className='animable'
					fill='#263238'
					transform-origin='237.42px 202.184px'
				/>
				<path
					d='M263.75 218.22a8.53 8.53 0 0 0-7-1.88c-2.31.21-4.9 1.27-7.86 2.23a19.18 19.18 0 0 1-4.81 1 22.34 22.34 0 0 1-5.25-.33c-3.55-.62-6.8-1.72-9.79-2.47a30 30 0 0 0-8.07-1.06 15.06 15.06 0 0 0-5.36 1.06c-1.2.51-1.8.93-1.83.88s.14-.12.43-.32a10.47 10.47 0 0 1 1.31-.75 14.44 14.44 0 0 1 5.43-1.24 28.94 28.94 0 0 1 8.21 1c3 .73 6.26 1.81 9.76 2.42a22.42 22.42 0 0 0 5.08.24 19.2 19.2 0 0 0 4.7-.92c2.93-.92 5.58-2 8-2.13a9.65 9.65 0 0 1 5.47 1 4.55 4.55 0 0 1 1.58 1.27Z'
					className='animable'
					fill='#263238'
					transform-origin='238.763px 217.468px'
				/>
				<path
					d='M264.78 235.28s0 .05-.11.1a1.9 1.9 0 0 1-.35.23 4.61 4.61 0 0 1-1.52.52 7.13 7.13 0 0 1-2.54-.07 16.15 16.15 0 0 1-3.19-1.07 23.57 23.57 0 0 0-8.27-2.19 21.66 21.66 0 0 0-5.05.21 44.37 44.37 0 0 0-5.31 1.28 49.46 49.46 0 0 1-5.35 1.37 26.22 26.22 0 0 1-5.14.45 28.28 28.28 0 0 1-8.59-1.41 27.11 27.11 0 0 1-5.34-2.43 15 15 0 0 1-1.34-.88c-.3-.21-.45-.32-.44-.34s.67.39 1.88 1a28.86 28.86 0 0 0 13.88 3.58 27.85 27.85 0 0 0 5.05-.47 54.51 54.51 0 0 0 5.3-1.37 43.25 43.25 0 0 1 5.38-1.29 22 22 0 0 1 5.16-.18 23.24 23.24 0 0 1 8.38 2.34 16.83 16.83 0 0 0 3.1 1.12 7.35 7.35 0 0 0 2.45.15 6.11 6.11 0 0 0 1.96-.65Z'
					className='animable'
					fill='#263238'
					transform-origin='238.51px 233.631px'
				/>
				<path
					d='M182.17 190.43c.05 0 .16.29.52.73a4.81 4.81 0 0 0 1.94 1.32 11.74 11.74 0 0 0 3.49.71 11.94 11.94 0 0 1 4.39 1 8.6 8.6 0 0 1 3.11 3.29 21.87 21.87 0 0 0 2 3 7 7 0 0 0 2.63 1.9 1.87 1.87 0 0 1-.88-.2 5.93 5.93 0 0 1-2-1.46 17.84 17.84 0 0 1-2.14-3 8.59 8.59 0 0 0-2.95-3.08 11.94 11.94 0 0 0-4.21-1 11.48 11.48 0 0 1-3.58-.85 4.67 4.67 0 0 1-2-1.54 1.78 1.78 0 0 1-.32-.82Z'
					className='animable'
					fill='#263238'
					transform-origin='191.21px 196.405px'
				/>
				<path
					d='M194.47 210.62s-.18.27-.65.59a5.68 5.68 0 0 1-2.26.84 9.93 9.93 0 0 1-3.56-.14 37.22 37.22 0 0 1-4.13-1.29 15.32 15.32 0 0 0-4.11-.94 7.31 7.31 0 0 0-3.32.59 5.49 5.49 0 0 0-2.33 2 1.84 1.84 0 0 1 .35-.81 4.65 4.65 0 0 1 1.82-1.57 7.19 7.19 0 0 1 3.5-.74 14.4 14.4 0 0 1 4.26.93c1.45.5 2.8 1 4.06 1.31a10.34 10.34 0 0 0 3.41.25 7.53 7.53 0 0 0 2.96-1.02Z'
					className='animable'
					fill='#263238'
					transform-origin='184.29px 210.707px'
				/>
				<path
					d='M198.46 222.44c0 .05-.27-.07-.73-.12a3.27 3.27 0 0 0-1.88.46 5.65 5.65 0 0 0-2 2c-.6.95-1.07 2.12-1.8 3.26a6.34 6.34 0 0 1-2.89 2.48 6.63 6.63 0 0 1-3.06.51 5.39 5.39 0 0 1-2-.51 1.82 1.82 0 0 1-.65-.41 9.87 9.87 0 0 0 2.68.56 6.72 6.72 0 0 0 2.86-.59 6 6 0 0 0 2.64-2.33c.7-1.08 1.19-2.25 1.84-3.22a5.65 5.65 0 0 1 2.28-2.11 3.22 3.22 0 0 1 2.08-.33 1.33 1.33 0 0 1 .63.35Z'
					className='animable'
					fill='#263238'
					transform-origin='190.955px 226.544px'
				/>
				<path
					d='M205.55 234.26a6 6 0 0 1-.74 2.27 12.77 12.77 0 0 1-8.92 6.83 6.15 6.15 0 0 1-2.39.12c0-.09.91-.12 2.31-.48a13.93 13.93 0 0 0 5-2.43 14.07 14.07 0 0 0 3.67-4.21c.71-1.26.98-2.13 1.07-2.1Z'
					className='animable'
					fill='#263238'
					transform-origin='199.525px 238.902px'
				/>
				<path
					d='M288.15 193a1.48 1.48 0 0 1-.18.86 3.91 3.91 0 0 1-1.66 1.72 6.5 6.5 0 0 1-3.46.78c-1.34 0-2.77-.28-4.25-.28a12.8 12.8 0 0 0-7.13 2.25c-1.62 1.11-2.37 2.1-2.45 2a2.62 2.62 0 0 1 .5-.71 10.87 10.87 0 0 1 1.73-1.62 12.38 12.38 0 0 1 7.35-2.47c1.55 0 3 .29 4.26.32a6.43 6.43 0 0 0 3.27-.62 3.9 3.9 0 0 0 1.65-1.5c.27-.4.33-.73.37-.73Z'
					className='animable'
					fill='#263238'
					transform-origin='278.588px 196.668px'
				/>
				<path
					d='M296 211.58a6.94 6.94 0 0 0-.77-.43 3.43 3.43 0 0 0-2.3-.05 14.92 14.92 0 0 0-3.16 1.68 18.83 18.83 0 0 1-4.09 1.87 9.53 9.53 0 0 1-4.52.31 7.32 7.32 0 0 1-3.35-1.58 5.26 5.26 0 0 1-1.49-2 3.93 3.93 0 0 1-.2-.65.55.55 0 0 1 0-.24 6.85 6.85 0 0 0 1.95 2.6 7.21 7.21 0 0 0 3.2 1.4 9.37 9.37 0 0 0 4.28-.34 20.4 20.4 0 0 0 4-1.78 14.17 14.17 0 0 1 3.3-1.63 3.49 3.49 0 0 1 2.49.22c.51.3.66.61.66.62Z'
					className='animable'
					fill='#263238'
					transform-origin='286.053px 212.795px'
				/>
				<path
					d='M282.49 238.32a7.52 7.52 0 0 0-.39-2.66 5.5 5.5 0 0 0-1.67-2.31 7 7 0 0 0-3.29-1.23 14.31 14.31 0 0 1-1.88-.45 6.19 6.19 0 0 1-1.64-.84 6.56 6.56 0 0 1-2-2.33 6.16 6.16 0 0 1-.6-2 1.77 1.77 0 0 1 0-.75 10.26 10.26 0 0 0 .91 2.55 6.41 6.41 0 0 0 1.95 2.12 8 8 0 0 0 3.34 1.17 7.1 7.1 0 0 1 3.49 1.37 5.54 5.54 0 0 1 1.72 2.55 4.93 4.93 0 0 1 .23 2.06 1.58 1.58 0 0 1-.17.75Z'
					className='animable'
					fill='#263238'
					transform-origin='276.832px 232.035px'
				/>
				<path
					d='M199.18 189.5c-.14 0-.37-.61-.52-1.43s-.14-1.49 0-1.51.37.61.52 1.42.14 1.49 0 1.52Z'
					className='animable'
					fill='#fff'
					transform-origin='198.92px 188.03px'
				/>
				<path
					d='M208.62 175.76c0 .14-.71.41-1.65.59s-1.73.22-1.76.08.72-.4 1.66-.59 1.72-.22 1.75-.08Z'
					className='animable'
					fill='#fff'
					transform-origin='206.915px 176.093px'
				/>
				<path
					d='M230 180.1c-.1.11-.73-.29-1.42-.89s-1.16-1.18-1.06-1.29.72.3 1.41.9S230 180 230 180.1Z'
					className='animable'
					fill='#fff'
					transform-origin='228.753px 179.01px'
				/>
				<path
					d='M254.84 178.75c.11.1-.5.95-1.35 1.9s-1.64 1.64-1.75 1.54.5-.94 1.36-1.89 1.64-1.64 1.74-1.55Z'
					className='animable'
					fill='#fff'
					transform-origin='253.29px 180.471px'
				/>
				<path
					d='M270.65 179.73c-.08.12-.88-.31-1.79-.95s-1.57-1.25-1.48-1.37.88.31 1.78 1 1.57 1.2 1.49 1.32Z'
					className='animable'
					fill='#fff'
					transform-origin='269.014px 178.57px'
				/>
				<path
					d='M221.42 210.77a3.74 3.74 0 0 1-2.25-.88c-1.12-.76-1.74-1.69-1.63-1.78s.87.63 1.93 1.35 2 1.16 1.95 1.31Z'
					className='animable'
					fill='#fff'
					transform-origin='219.475px 209.436px'
				/>
				<path
					d='M238.28 209.41c.1.1-.57.93-1.5 1.84s-1.76 1.58-1.86 1.48.57-.93 1.5-1.85 1.76-1.57 1.86-1.47Z'
					className='animable'
					fill='#fff'
					transform-origin='236.6px 211.07px'
				/>
				<path
					d='M250.32 212.27a5.7 5.7 0 0 1-2.15-1c-1.12-.69-2-1.34-1.88-1.47a5.7 5.7 0 0 1 2.15 1c1.12.69 1.96 1.34 1.88 1.47Z'
					className='animable'
					fill='#fff'
					transform-origin='248.302px 211.035px'
				/>
				<path
					d='M261.51 209.14c.1.11-.25.55-.76 1s-1 .69-1.1.58.25-.55.77-1 1-.72 1.09-.58Z'
					className='animable'
					fill='#fff'
					transform-origin='260.58px 209.925px'
				/>
				<path
					d='M256 194.38c-.13 0 .05-.93.62-1.87s1.26-1.53 1.36-1.44-.38.81-.91 1.7-.9 1.66-1.07 1.61Z'
					className='animable'
					fill='#fff'
					transform-origin='256.977px 192.722px'
				/>
				<path
					d='M243.13 191.63c-.1.11-.67-.26-1.27-.82s-1-1.09-.91-1.2.66.26 1.27.82 1 1.09.91 1.2Z'
					className='animable'
					fill='#fff'
					transform-origin='242.04px 190.62px'
				/>
				<path
					d='M225 194.9c.1.1-.3.64-.9 1.2s-1.17.93-1.27.82.31-.64.91-1.2 1.14-.93 1.26-.82Z'
					className='animable'
					fill='#fff'
					transform-origin='223.915px 195.91px'
				/>
				<path
					d='M273.93 192c-.08.12-.7-.16-1.39-.64s-1.17-.95-1.09-1.07.7.17 1.39.64 1.16.94 1.09 1.07Z'
					className='animable'
					fill='#fff'
					transform-origin='272.689px 191.145px'
				/>
				<path
					d='M281 203.37a5 5 0 0 1-.51 2.17c-.41 1.15-.86 2-1 2a5.14 5.14 0 0 1 .51-2.17c.38-1.16.82-2.05 1-2Z'
					className='animable'
					fill='#fff'
					transform-origin='280.245px 205.454px'
				/>
				<path
					d='M278 224.48c-.13.05-.56-.7-.94-1.69s-.59-1.83-.46-1.88.56.7.94 1.69.62 1.83.46 1.88Z'
					className='animable'
					fill='#fff'
					transform-origin='277.306px 222.695px'
				/>
				<path
					d='M271.5 239c-.15 0-.16-.81-.25-1.78s-.21-1.75-.07-1.79.5.72.59 1.75-.14 1.82-.27 1.82Z'
					className='animable'
					fill='#fff'
					transform-origin='271.453px 237.214px'
				/>
				<path
					d='M256.61 224.12c.09.1-.43.73-1.18 1.4s-1.42 1.13-1.52 1 .43-.74 1.18-1.41 1.42-1.11 1.52-.99Z'
					className='animable'
					fill='#fff'
					transform-origin='255.259px 225.321px'
				/>
				<path
					d='M246 227.2c-.11.09-.76-.61-1.45-1.56s-1.14-1.78-1-1.87.76.62 1.45 1.57 1.09 1.78 1 1.86Z'
					className='animable'
					fill='#fff'
					transform-origin='244.769px 225.485px'
				/>
				<path
					d='M231.25 224.58c.11.1-.42.85-1.19 1.67s-1.46 1.42-1.57 1.32.43-.85 1.19-1.67 1.47-1.41 1.57-1.32Z'
					className='animable'
					fill='#fff'
					transform-origin='229.87px 226.076px'
				/>
				<path
					d='M220.52 227.22c-.12.08-.6-.45-1.08-1.17s-.76-1.39-.64-1.47.61.45 1.08 1.18.76 1.38.64 1.46Z'
					className='animable'
					fill='#fff'
					transform-origin='219.66px 225.9px'
				/>
				<path
					d='M220.29 243.48c-.1.1-.6-.23-1.13-.73s-.87-1-.77-1.1.61.22 1.13.72.87 1 .77 1.11Z'
					className='animable'
					fill='#fff'
					transform-origin='219.34px 242.565px'
				/>
				<path
					d='M232.05 241.82c.11.1-.22.63-.74 1.19s-1 .93-1.12.84.23-.63.74-1.19 1.07-.93 1.12-.84Z'
					className='animable'
					fill='#fff'
					transform-origin='231.119px 242.835px'
				/>
				<path
					d='M247 244.88c-.12.09-.95-.81-1.86-2a7.17 7.17 0 0 1-1.45-2.31c.11-.09.94.8 1.86 2a7.6 7.6 0 0 1 1.45 2.31Z'
					className='animable'
					fill='#fff'
					transform-origin='245.345px 242.725px'
				/>
				<path
					d='M258.89 241.75c.1.1-.59.94-1.55 1.86s-1.82 1.6-1.92 1.5.6-.94 1.56-1.87 1.81-1.6 1.91-1.49Z'
					className='animable'
					fill='#fff'
					transform-origin='257.155px 243.429px'
				/>
				<path
					d='M194 236.9c-.14 0-.19-.89-.1-2s.27-1.93.41-1.92.19.89.11 2-.31 1.93-.42 1.92Z'
					className='animable'
					fill='#fff'
					transform-origin='194.156px 234.94px'
				/>
				<path
					d='M200.33 232.69c-.06.13-.73 0-1.51-.38s-1.35-.73-1.29-.86.73 0 1.5.38 1.36.73 1.3.86Z'
					className='animable'
					fill='#fff'
					transform-origin='198.93px 232.07px'
				/>
				<path
					d='M184.93 221.54c0 .14-.79.08-1.69-.14s-1.61-.5-1.58-.64.79-.08 1.7.14 1.64.5 1.57.64Z'
					className='animable'
					fill='#fff'
					transform-origin='183.297px 221.15px'
				/>
				<path
					d='M191.14 219a5.14 5.14 0 0 1 .77-2.13c.56-1.12 1.11-2 1.24-1.91a5.2 5.2 0 0 1-.77 2.14c-.56 1.14-1.11 2-1.24 1.9Z'
					className='animable'
					fill='#fff'
					transform-origin='192.145px 216.981px'
				/>
				<path
					d='M180.19 198.71c.14-.05.58.87 1.23 1.91s1.26 1.85 1.16 1.95-.92-.57-1.6-1.68-.93-2.13-.79-2.18Z'
					className='animable'
					fill='#fff'
					transform-origin='181.372px 200.644px'
				/>
				<path
					d='M189.09 202.71c0 .15-.42.34-.9.67s-.83.67-.95.59.07-.63.66-1 1.18-.4 1.19-.26Z'
					className='animable'
					fill='#fff'
					transform-origin='188.148px 203.307px'
				/>
				<path
					d='M220.28 169.11c-.13.07-.68-.71-1.24-1.74a4.72 4.72 0 0 1-.79-2c.13-.07.69.71 1.24 1.74a4.63 4.63 0 0 1 .79 2Z'
					className='animable'
					fill='#fff'
					transform-origin='219.265px 167.24px'
				/>
				<path
					d='M233.47 165.83c.08.12-.72.81-1.79 1.54a5.71 5.71 0 0 1-2.09 1.11c-.08-.12.72-.81 1.8-1.54s2-1.23 2.08-1.11Z'
					className='animable'
					fill='#fff'
					transform-origin='231.53px 167.146px'
				/>
				<path
					d='M252.75 168.13a12.36 12.36 0 0 1-4.36-2.63 6.14 6.14 0 0 1 2.31 1.09 6.58 6.58 0 0 1 2.05 1.54Z'
					className='animable'
					fill='#fff'
					transform-origin='250.57px 166.815px'
				/>
				<path
					d='M261.4 165c.14 0 .12.87 0 1.9s-.43 1.85-.57 1.82-.12-.87.05-1.9.38-1.82.52-1.82Z'
					className='animable'
					fill='#fff'
					transform-origin='261.117px 166.86px'
				/>
				<path
					d='M267.75 170.76a2.47 2.47 0 0 1-.35.59 7.81 7.81 0 0 1-1.37 1.42 11 11 0 0 1-6.82 2.19 20.08 20.08 0 0 1-5-.72c-1.75-.45-3.56-1.09-5.46-1.74a33.51 33.51 0 0 0-6-1.57 16 16 0 0 0-6.6.49c-4.41 1.22-8.41 3.46-12.56 3.69a12.79 12.79 0 0 1-3-.17 12 12 0 0 1-2.68-.88 24.1 24.1 0 0 1-4.27-2.62 45.31 45.31 0 0 0-5.92-4c-1.51-.77-2.44-1-2.42-1a3.16 3.16 0 0 1 .67.16 11.2 11.2 0 0 1 1.84.7 40.51 40.51 0 0 1 6.05 3.93 24.37 24.37 0 0 0 4.23 2.52 12.54 12.54 0 0 0 2.58.82 11.85 11.85 0 0 0 2.87.14c4-.24 7.95-2.46 12.46-3.71a16.27 16.27 0 0 1 6.8-.5 33.22 33.22 0 0 1 6.14 1.63c1.9.66 3.69 1.31 5.41 1.77a20.05 20.05 0 0 0 4.85.77 11.09 11.09 0 0 0 6.7-2 10.53 10.53 0 0 0 1.85-1.91Z'
					className='animable'
					fill='#263238'
					transform-origin='236.525px 170.787px'
				/>
				<path
					d='m280.57 184.5-.24-.07-.66-.25a20.39 20.39 0 0 0-2.63-.76 20.72 20.72 0 0 0-9.91.2 19.12 19.12 0 0 0-3.11 1.12c-1 .48-2.09 1.08-3.19 1.69a22.65 22.65 0 0 1-3.54 1.67 11 11 0 0 1-2 .49 9.58 9.58 0 0 1-2.14 0c-2.9-.36-5.49-2-8.3-3.11a12.06 12.06 0 0 0-4.45-.94 15.63 15.63 0 0 0-4.64.82c-3.07 1-5.93 2.44-9 3.12a15.35 15.35 0 0 1-8.82-.72 44.2 44.2 0 0 1-7.19-3.57 54.73 54.73 0 0 0-6.15-3.19 15.61 15.61 0 0 0-9.76-1.2 12 12 0 0 0-3.36 1.45l.19-.16a6 6 0 0 1 .59-.41 9 9 0 0 1 2.54-1.07 13.08 13.08 0 0 1 4.34-.36 18.26 18.26 0 0 1 5.6 1.41 52.48 52.48 0 0 1 6.22 3.18 45.13 45.13 0 0 0 7.14 3.49 15 15 0 0 0 8.55.67c3-.66 5.81-2.11 8.93-3.11a15.53 15.53 0 0 1 4.8-.84 12.27 12.27 0 0 1 4.64 1c2.86 1.14 5.42 2.75 8.17 3.1a8.54 8.54 0 0 0 2 0 9.51 9.51 0 0 0 1.93-.45 23.07 23.07 0 0 0 3.48-1.62c1.1-.59 2.16-1.2 3.23-1.67a19.53 19.53 0 0 1 3.18-1.12 20.57 20.57 0 0 1 10.06 0 14.09 14.09 0 0 1 3.5 1.21Z'
					className='animable'
					fill='#263238'
					transform-origin='236.025px 184.012px'
				/>
				<path
					d='M263.09 204.1a2.13 2.13 0 0 1-.43.34 4.33 4.33 0 0 1-1.48.59 8.59 8.59 0 0 1-5.66-1c-1.11-.54-2.26-1.24-3.53-1.86a15.73 15.73 0 0 0-4.29-1.35 28.67 28.67 0 0 0-10.33.56c-3.63.75-7.07 1.71-10.29 2.13a22.14 22.14 0 0 1-8.59-.3 13.54 13.54 0 0 1-5.23-2.48 8.07 8.07 0 0 1-1.16-1.08 2.21 2.21 0 0 1-.35-.43s.54.55 1.63 1.35a14.14 14.14 0 0 0 5.2 2.29 22.5 22.5 0 0 0 8.42.14c3.18-.45 6.6-1.41 10.26-2.17a28.44 28.44 0 0 1 10.51-.52 16 16 0 0 1 4.4 1.43c1.29.66 2.42 1.37 3.5 1.92a8.66 8.66 0 0 0 5.46 1.17 6.43 6.43 0 0 0 1.96-.73Z'
					className='animable'
					fill='#263238'
					transform-origin='237.42px 202.184px'
				/>
				<path
					d='M263.75 218.22a8.53 8.53 0 0 0-7-1.88c-2.31.21-4.9 1.27-7.86 2.23a19.18 19.18 0 0 1-4.81 1 22.34 22.34 0 0 1-5.25-.33c-3.55-.62-6.8-1.72-9.79-2.47a30 30 0 0 0-8.07-1.06 15.06 15.06 0 0 0-5.36 1.06c-1.2.51-1.8.93-1.83.88s.14-.12.43-.32a10.47 10.47 0 0 1 1.31-.75 14.44 14.44 0 0 1 5.43-1.24 28.94 28.94 0 0 1 8.21 1c3 .73 6.26 1.81 9.76 2.42a22.42 22.42 0 0 0 5.08.24 19.2 19.2 0 0 0 4.7-.92c2.93-.92 5.58-2 8-2.13a9.65 9.65 0 0 1 5.47 1 4.55 4.55 0 0 1 1.58 1.27Z'
					className='animable'
					fill='#263238'
					transform-origin='238.763px 217.468px'
				/>
				<path
					d='M264.78 235.28s0 .05-.11.1a1.9 1.9 0 0 1-.35.23 4.61 4.61 0 0 1-1.52.52 7.13 7.13 0 0 1-2.54-.07 16.15 16.15 0 0 1-3.19-1.07 23.57 23.57 0 0 0-8.27-2.19 21.66 21.66 0 0 0-5.05.21 44.37 44.37 0 0 0-5.31 1.28 49.46 49.46 0 0 1-5.35 1.37 26.22 26.22 0 0 1-5.14.45 28.28 28.28 0 0 1-8.59-1.41 27.11 27.11 0 0 1-5.34-2.43 15 15 0 0 1-1.34-.88c-.3-.21-.45-.32-.44-.34s.67.39 1.88 1a28.86 28.86 0 0 0 13.88 3.58 27.85 27.85 0 0 0 5.05-.47 54.51 54.51 0 0 0 5.3-1.37 43.25 43.25 0 0 1 5.38-1.29 22 22 0 0 1 5.16-.18 23.24 23.24 0 0 1 8.38 2.34 16.83 16.83 0 0 0 3.1 1.12 7.35 7.35 0 0 0 2.45.15 6.11 6.11 0 0 0 1.96-.65Z'
					className='animable'
					fill='#263238'
					transform-origin='238.51px 233.631px'
				/>
				<path
					d='M182.17 190.43c.05 0 .16.29.52.73a4.81 4.81 0 0 0 1.94 1.32 11.74 11.74 0 0 0 3.49.71 11.94 11.94 0 0 1 4.39 1 8.6 8.6 0 0 1 3.11 3.29 21.87 21.87 0 0 0 2 3 7 7 0 0 0 2.63 1.9 1.87 1.87 0 0 1-.88-.2 5.93 5.93 0 0 1-2-1.46 17.84 17.84 0 0 1-2.14-3 8.59 8.59 0 0 0-2.95-3.08 11.94 11.94 0 0 0-4.21-1 11.48 11.48 0 0 1-3.58-.85 4.67 4.67 0 0 1-2-1.54 1.78 1.78 0 0 1-.32-.82Z'
					className='animable'
					fill='#263238'
					transform-origin='191.21px 196.405px'
				/>
				<path
					d='M194.47 210.62s-.18.27-.65.59a5.68 5.68 0 0 1-2.26.84 9.93 9.93 0 0 1-3.56-.14 37.22 37.22 0 0 1-4.13-1.29 15.32 15.32 0 0 0-4.11-.94 7.31 7.31 0 0 0-3.32.59 5.49 5.49 0 0 0-2.33 2 1.84 1.84 0 0 1 .35-.81 4.65 4.65 0 0 1 1.82-1.57 7.19 7.19 0 0 1 3.5-.74 14.4 14.4 0 0 1 4.26.93c1.45.5 2.8 1 4.06 1.31a10.34 10.34 0 0 0 3.41.25 7.53 7.53 0 0 0 2.96-1.02Z'
					className='animable'
					fill='#263238'
					transform-origin='184.29px 210.707px'
				/>
				<path
					d='M198.46 222.44c0 .05-.27-.07-.73-.12a3.27 3.27 0 0 0-1.88.46 5.65 5.65 0 0 0-2 2c-.6.95-1.07 2.12-1.8 3.26a6.34 6.34 0 0 1-2.89 2.48 6.63 6.63 0 0 1-3.06.51 5.39 5.39 0 0 1-2-.51 1.82 1.82 0 0 1-.65-.41 9.87 9.87 0 0 0 2.68.56 6.72 6.72 0 0 0 2.86-.59 6 6 0 0 0 2.64-2.33c.7-1.08 1.19-2.25 1.84-3.22a5.65 5.65 0 0 1 2.28-2.11 3.22 3.22 0 0 1 2.08-.33 1.33 1.33 0 0 1 .63.35Z'
					className='animable'
					fill='#263238'
					transform-origin='190.955px 226.544px'
				/>
				<path
					d='M205.55 234.26a6 6 0 0 1-.74 2.27 12.77 12.77 0 0 1-8.92 6.83 6.15 6.15 0 0 1-2.39.12c0-.09.91-.12 2.31-.48a13.93 13.93 0 0 0 5-2.43 14.07 14.07 0 0 0 3.67-4.21c.71-1.26.98-2.13 1.07-2.1Z'
					className='animable'
					fill='#263238'
					transform-origin='199.525px 238.902px'
				/>
				<path
					d='M288.15 193a1.48 1.48 0 0 1-.18.86 3.91 3.91 0 0 1-1.66 1.72 6.5 6.5 0 0 1-3.46.78c-1.34 0-2.77-.28-4.25-.28a12.8 12.8 0 0 0-7.13 2.25c-1.62 1.11-2.37 2.1-2.45 2a2.62 2.62 0 0 1 .5-.71 10.87 10.87 0 0 1 1.73-1.62 12.38 12.38 0 0 1 7.35-2.47c1.55 0 3 .29 4.26.32a6.43 6.43 0 0 0 3.27-.62 3.9 3.9 0 0 0 1.65-1.5c.27-.4.33-.73.37-.73Z'
					className='animable'
					fill='#263238'
					transform-origin='278.588px 196.668px'
				/>
				<path
					d='M296 211.58a6.94 6.94 0 0 0-.77-.43 3.43 3.43 0 0 0-2.3-.05 14.92 14.92 0 0 0-3.16 1.68 18.83 18.83 0 0 1-4.09 1.87 9.53 9.53 0 0 1-4.52.31 7.32 7.32 0 0 1-3.35-1.58 5.26 5.26 0 0 1-1.49-2 3.93 3.93 0 0 1-.2-.65.55.55 0 0 1 0-.24 6.85 6.85 0 0 0 1.95 2.6 7.21 7.21 0 0 0 3.2 1.4 9.37 9.37 0 0 0 4.28-.34 20.4 20.4 0 0 0 4-1.78 14.17 14.17 0 0 1 3.3-1.63 3.49 3.49 0 0 1 2.49.22c.51.3.66.61.66.62Z'
					className='animable'
					fill='#263238'
					transform-origin='286.053px 212.795px'
				/>
				<path
					d='M282.49 238.32a7.52 7.52 0 0 0-.39-2.66 5.5 5.5 0 0 0-1.67-2.31 7 7 0 0 0-3.29-1.23 14.31 14.31 0 0 1-1.88-.45 6.19 6.19 0 0 1-1.64-.84 6.56 6.56 0 0 1-2-2.33 6.16 6.16 0 0 1-.6-2 1.77 1.77 0 0 1 0-.75 10.26 10.26 0 0 0 .91 2.55 6.41 6.41 0 0 0 1.95 2.12 8 8 0 0 0 3.34 1.17 7.1 7.1 0 0 1 3.49 1.37 5.54 5.54 0 0 1 1.72 2.55 4.93 4.93 0 0 1 .23 2.06 1.58 1.58 0 0 1-.17.75Z'
					className='animable'
					fill='#263238'
					transform-origin='276.832px 232.035px'
				/>
				<path
					d='M199.18 189.5c-.14 0-.37-.61-.52-1.43s-.14-1.49 0-1.51.37.61.52 1.42.14 1.49 0 1.52Z'
					className='animable'
					fill='#fff'
					transform-origin='198.92px 188.03px'
				/>
				<path
					d='M208.62 175.76c0 .14-.71.41-1.65.59s-1.73.22-1.76.08.72-.4 1.66-.59 1.72-.22 1.75-.08Z'
					className='animable'
					fill='#fff'
					transform-origin='206.915px 176.093px'
				/>
				<path
					d='M230 180.1c-.1.11-.73-.29-1.42-.89s-1.16-1.18-1.06-1.29.72.3 1.41.9S230 180 230 180.1Z'
					className='animable'
					fill='#fff'
					transform-origin='228.753px 179.01px'
				/>
				<path
					d='M254.84 178.75c.11.1-.5.95-1.35 1.9s-1.64 1.64-1.75 1.54.5-.94 1.36-1.89 1.64-1.64 1.74-1.55Z'
					className='animable'
					fill='#fff'
					transform-origin='253.29px 180.471px'
				/>
				<path
					d='M270.65 179.73c-.08.12-.88-.31-1.79-.95s-1.57-1.25-1.48-1.37.88.31 1.78 1 1.57 1.2 1.49 1.32Z'
					className='animable'
					fill='#fff'
					transform-origin='269.014px 178.57px'
				/>
				<path
					d='M221.42 210.77a3.74 3.74 0 0 1-2.25-.88c-1.12-.76-1.74-1.69-1.63-1.78s.87.63 1.93 1.35 2 1.16 1.95 1.31Z'
					className='animable'
					fill='#fff'
					transform-origin='219.475px 209.436px'
				/>
				<path
					d='M238.28 209.41c.1.1-.57.93-1.5 1.84s-1.76 1.58-1.86 1.48.57-.93 1.5-1.85 1.76-1.57 1.86-1.47Z'
					className='animable'
					fill='#fff'
					transform-origin='236.6px 211.07px'
				/>
				<path
					d='M250.32 212.27a5.7 5.7 0 0 1-2.15-1c-1.12-.69-2-1.34-1.88-1.47a5.7 5.7 0 0 1 2.15 1c1.12.69 1.96 1.34 1.88 1.47Z'
					className='animable'
					fill='#fff'
					transform-origin='248.302px 211.035px'
				/>
				<path
					d='M261.51 209.14c.1.11-.25.55-.76 1s-1 .69-1.1.58.25-.55.77-1 1-.72 1.09-.58Z'
					className='animable'
					fill='#fff'
					transform-origin='260.58px 209.925px'
				/>
				<path
					d='M256 194.38c-.13 0 .05-.93.62-1.87s1.26-1.53 1.36-1.44-.38.81-.91 1.7-.9 1.66-1.07 1.61Z'
					className='animable'
					fill='#fff'
					transform-origin='256.977px 192.722px'
				/>
				<path
					d='M243.13 191.63c-.1.11-.67-.26-1.27-.82s-1-1.09-.91-1.2.66.26 1.27.82 1 1.09.91 1.2Z'
					className='animable'
					fill='#fff'
					transform-origin='242.04px 190.62px'
				/>
				<path
					d='M225 194.9c.1.1-.3.64-.9 1.2s-1.17.93-1.27.82.31-.64.91-1.2 1.14-.93 1.26-.82Z'
					className='animable'
					fill='#fff'
					transform-origin='223.915px 195.91px'
				/>
				<path
					d='M273.93 192c-.08.12-.7-.16-1.39-.64s-1.17-.95-1.09-1.07.7.17 1.39.64 1.16.94 1.09 1.07Z'
					className='animable'
					fill='#fff'
					transform-origin='272.689px 191.145px'
				/>
				<path
					d='M281 203.37a5 5 0 0 1-.51 2.17c-.41 1.15-.86 2-1 2a5.14 5.14 0 0 1 .51-2.17c.38-1.16.82-2.05 1-2Z'
					className='animable'
					fill='#fff'
					transform-origin='280.245px 205.454px'
				/>
				<path
					d='M278 224.48c-.13.05-.56-.7-.94-1.69s-.59-1.83-.46-1.88.56.7.94 1.69.62 1.83.46 1.88Z'
					className='animable'
					fill='#fff'
					transform-origin='277.306px 222.695px'
				/>
				<path
					d='M271.5 239c-.15 0-.16-.81-.25-1.78s-.21-1.75-.07-1.79.5.72.59 1.75-.14 1.82-.27 1.82Z'
					className='animable'
					fill='#fff'
					transform-origin='271.453px 237.214px'
				/>
				<path
					d='M256.61 224.12c.09.1-.43.73-1.18 1.4s-1.42 1.13-1.52 1 .43-.74 1.18-1.41 1.42-1.11 1.52-.99Z'
					className='animable'
					fill='#fff'
					transform-origin='255.259px 225.321px'
				/>
				<path
					d='M246 227.2c-.11.09-.76-.61-1.45-1.56s-1.14-1.78-1-1.87.76.62 1.45 1.57 1.09 1.78 1 1.86Z'
					className='animable'
					fill='#fff'
					transform-origin='244.769px 225.485px'
				/>
				<path
					d='M231.25 224.58c.11.1-.42.85-1.19 1.67s-1.46 1.42-1.57 1.32.43-.85 1.19-1.67 1.47-1.41 1.57-1.32Z'
					className='animable'
					fill='#fff'
					transform-origin='229.87px 226.076px'
				/>
				<path
					d='M220.52 227.22c-.12.08-.6-.45-1.08-1.17s-.76-1.39-.64-1.47.61.45 1.08 1.18.76 1.38.64 1.46Z'
					className='animable'
					fill='#fff'
					transform-origin='219.66px 225.9px'
				/>
				<path
					d='M220.29 243.48c-.1.1-.6-.23-1.13-.73s-.87-1-.77-1.1.61.22 1.13.72.87 1 .77 1.11Z'
					className='animable'
					fill='#fff'
					transform-origin='219.34px 242.565px'
				/>
				<path
					d='M232.05 241.82c.11.1-.22.63-.74 1.19s-1 .93-1.12.84.23-.63.74-1.19 1.07-.93 1.12-.84Z'
					className='animable'
					fill='#fff'
					transform-origin='231.119px 242.835px'
				/>
				<path
					d='M247 244.88c-.12.09-.95-.81-1.86-2a7.17 7.17 0 0 1-1.45-2.31c.11-.09.94.8 1.86 2a7.6 7.6 0 0 1 1.45 2.31Z'
					className='animable'
					fill='#fff'
					transform-origin='245.345px 242.725px'
				/>
				<path
					d='M258.89 241.75c.1.1-.59.94-1.55 1.86s-1.82 1.6-1.92 1.5.6-.94 1.56-1.87 1.81-1.6 1.91-1.49Z'
					className='animable'
					fill='#fff'
					transform-origin='257.155px 243.429px'
				/>
				<path
					d='M194 236.9c-.14 0-.19-.89-.1-2s.27-1.93.41-1.92.19.89.11 2-.31 1.93-.42 1.92Z'
					className='animable'
					fill='#fff'
					transform-origin='194.156px 234.94px'
				/>
				<path
					d='M200.33 232.69c-.06.13-.73 0-1.51-.38s-1.35-.73-1.29-.86.73 0 1.5.38 1.36.73 1.3.86Z'
					className='animable'
					fill='#fff'
					transform-origin='198.93px 232.07px'
				/>
				<path
					d='M184.93 221.54c0 .14-.79.08-1.69-.14s-1.61-.5-1.58-.64.79-.08 1.7.14 1.64.5 1.57.64Z'
					className='animable'
					fill='#fff'
					transform-origin='183.297px 221.15px'
				/>
				<path
					d='M191.14 219a5.14 5.14 0 0 1 .77-2.13c.56-1.12 1.11-2 1.24-1.91a5.2 5.2 0 0 1-.77 2.14c-.56 1.14-1.11 2-1.24 1.9Z'
					className='animable'
					fill='#fff'
					transform-origin='192.145px 216.981px'
				/>
				<path
					d='M180.19 198.71c.14-.05.58.87 1.23 1.91s1.26 1.85 1.16 1.95-.92-.57-1.6-1.68-.93-2.13-.79-2.18Z'
					className='animable'
					fill='#fff'
					transform-origin='181.372px 200.644px'
				/>
				<path
					d='M189.09 202.71c0 .15-.42.34-.9.67s-.83.67-.95.59.07-.63.66-1 1.18-.4 1.19-.26Z'
					className='animable'
					fill='#fff'
					transform-origin='188.148px 203.307px'
				/>
				<path
					d='M220.28 169.11c-.13.07-.68-.71-1.24-1.74a4.72 4.72 0 0 1-.79-2c.13-.07.69.71 1.24 1.74a4.63 4.63 0 0 1 .79 2Z'
					className='animable'
					fill='#fff'
					transform-origin='219.265px 167.24px'
				/>
				<path
					d='M233.47 165.83c.08.12-.72.81-1.79 1.54a5.71 5.71 0 0 1-2.09 1.11c-.08-.12.72-.81 1.8-1.54s2-1.23 2.08-1.11Z'
					className='animable'
					fill='#fff'
					transform-origin='231.53px 167.146px'
				/>
				<path
					d='M252.75 168.13a12.36 12.36 0 0 1-4.36-2.63 6.14 6.14 0 0 1 2.31 1.09 6.58 6.58 0 0 1 2.05 1.54Z'
					className='animable'
					fill='#fff'
					transform-origin='250.57px 166.815px'
				/>
				<path
					d='M261.4 165c.14 0 .12.87 0 1.9s-.43 1.85-.57 1.82-.12-.87.05-1.9.38-1.82.52-1.82Z'
					className='animable'
					fill='#fff'
					transform-origin='261.117px 166.86px'
				/>
				<path
					d='M207.52 242.33a74.78 74.78 0 0 1 7.09 5.71c2.13 1.93-2 13.45-4.33 11.43s-8.62-10-8.62-10Z'
					className='animable'
					fill='#b78876'
					transform-origin='208.431px 251.018px'
				/>
				<path
					d='M210.61 259.67s-6.54-.72-6.36-2.07a7.32 7.32 0 0 1 1.61-3Z'
					className='animable'
					fill='#a36957'
					transform-origin='207.428px 257.135px'
				/>
			</g>
			<g id='garlands' className='animable'>
				<path
					d='M247.93 40.34s9.19 50.81 15.41 50.58c8-.3 35.3-42.61 35.3-42.61s-46.21-7.11-50.71-7.97Z'
					className='animable'
					fill='#f41760'
					transform-origin='273.285px 65.6304px'
				/>
				<g className='animable' opacity='.3'>
					<path
						d='M247.93 40.34s9.19 50.81 15.41 50.58c8-.3 35.3-42.61 35.3-42.61s-46.21-7.11-50.71-7.97Z'
						className='animable'
						fill='#fff'
						transform-origin='273.285px 65.6304px'
					/>
				</g>
				<path
					d='m267.11 56.53 5.52.2a.83.83 0 0 1 .32.06.63.63 0 0 1 .45.67.56.56 0 0 1-.07.26.83.83 0 0 1-.71.43l-4.95-.15-.8 4.67 3.57.13a.92.92 0 0 1 .38.09.66.66 0 0 1 .4.66.59.59 0 0 1-.05.23.81.81 0 0 1-.72.44l-3.8-.14-.73 4.37 4.9.18a1.16 1.16 0 0 1 .37.07.67.67 0 0 1 .42.67.6.6 0 0 1 0 .22.78.78 0 0 1-.73.46l-5.72-.21a.69.69 0 0 1-.39-.12.82.82 0 0 1-.31-.73q0-.13 2-11.8a.84.84 0 0 1 .07-.24.65.65 0 0 1 .58-.42Z'
					className='animable'
					fill='#263238'
					transform-origin='268.93px 63.2901px'
				/>
				<path
					d='M303.66 49.1s13.69 49.79 19.86 49c8-1 31.36-45.59 31.36-45.59s-46.67-2.95-51.22-3.41Z'
					className='animable'
					fill='#f41760'
					transform-origin='329.27px 73.6046px'
				/>
				<path
					d='m329.2 76.67-5.78.3a.62.62 0 0 1-.37-.09 1.07 1.07 0 0 1-.37-.7q0-.36 1-11.92a2.11 2.11 0 0 1 0-.25.69.69 0 0 1 .93-.39.64.64 0 0 1 .39.59c0 .52-.1 1.61-.22 3.26q-.6 7.64-.61 8.05l4.91-.26a1.14 1.14 0 0 1 .37 0 .64.64 0 0 1 .47.62.6.6 0 0 1 0 .23.8.8 0 0 1-.72.56Z'
					className='animable'
					fill='#263238'
					transform-origin='326.306px 70.2655px'
				/>
				<path
					d='M359.89 52.55s18.11 48.36 24.18 47c7.84-1.73 27.14-48.22 27.14-48.22s-46.75 1.27-51.32 1.22Z'
					className='animable'
					fill='#f41760'
					transform-origin='385.55px 75.4541px'
				/>
				<g className='animable' opacity='.3'>
					<path
						d='M359.89 52.55s18.11 48.36 24.18 47c7.84-1.73 27.14-48.22 27.14-48.22s-46.75 1.27-51.32 1.22Z'
						className='animable'
						fill='#fff'
						transform-origin='385.55px 75.4541px'
					/>
				</g>
				<path
					d='M386.77 67.41a4.19 4.19 0 0 0-.58-.77 1.92 1.92 0 0 0-1.6-.67 1.82 1.82 0 0 0-1 .54 5.55 5.55 0 0 0-1.37 2.73 9.57 9.57 0 0 0-.25 3.69 6.55 6.55 0 0 0 .95 2.73 1.88 1.88 0 0 0 1.84 1 1.92 1.92 0 0 0 1-.6 5.72 5.72 0 0 0 1.32-2.28.36.36 0 0 1 0-.11.61.61 0 0 1 .52-.42.69.69 0 0 1 .35 0 .65.65 0 0 1 .43.55.87.87 0 0 1 0 .34 7.39 7.39 0 0 1-1 2.17 3.79 3.79 0 0 1-2.55 1.74h-.38a3.08 3.08 0 0 1-2.39-1.24 7.1 7.1 0 0 1-1.51-3.68 10.24 10.24 0 0 1 0-2.82 9.13 9.13 0 0 1 1.36-3.92 3.85 3.85 0 0 1 2.62-1.91 2.85 2.85 0 0 1 1.26.1 4 4 0 0 1 2.17 2 .77.77 0 0 1 .11.31.61.61 0 0 1 0 .35.68.68 0 0 1-.54.43.83.83 0 0 1-.76-.26Z'
					className='animable'
					fill='#263238'
					transform-origin='384.425px 71.2502px'
				/>
				<path
					d='M413.55 51.43s20.91 47.22 26.9 45.57c7.72-2.19 24.26-49.74 24.26-49.74s-46.59 3.95-51.16 4.17Z'
					className='animable'
					fill='#f41760'
					transform-origin='439.13px 72.1511px'
				/>
				<path
					d='M435.28 70.87a10.33 10.33 0 0 1-.17-2.85 8.93 8.93 0 0 1 1.16-4 3.82 3.82 0 0 1 2.47-2 2.94 2.94 0 0 1 2.58.78 6.54 6.54 0 0 1 1.87 3.31c.17-.11.42-.29.74-.53a2.83 2.83 0 0 1 1-.56.58.58 0 0 1 .32 0 .61.61 0 0 1 .43.47 1 1 0 0 1-.17.67 4.39 4.39 0 0 1-2 1.36 10.86 10.86 0 0 1 .05 1.89 8.86 8.86 0 0 1-1.14 4.06 3.92 3.92 0 0 1-2.53 2h-.38a3.09 3.09 0 0 1-2.51-1.01 7.11 7.11 0 0 1-1.72-3.59Zm1.38-.53a7.55 7.55 0 0 0 1 2.58c.6.94 1.29 1.33 2.05 1.17a1.32 1.32 0 0 0 .57-.26 4.24 4.24 0 0 0 1.35-2.21 9.53 9.53 0 0 0 .45-3.67 4.2 4.2 0 0 1-2.43-.24 5.08 5.08 0 0 1-2.51-2.31 8.64 8.64 0 0 0-.48 4.94Zm2.66-6.85a.84.84 0 0 0-.38.18 1.15 1.15 0 0 0-.25 1.15 1.9 1.9 0 0 0 .09.29 2.33 2.33 0 0 0 1.48 1.33 3 3 0 0 0 1.58.19 8 8 0 0 0-.48-1.33c-.59-1.3-1.27-1.91-2.04-1.81Z'
					className='animable'
					fill='#263238'
					transform-origin='440.382px 68.7244px'
				/>
				<path
					d='M467.86 45.87s25.68 44.8 31.46 42.49c7.46-3 19-52 19-52s-45.94 8.82-50.46 9.51Z'
					className='animable'
					fill='#f41760'
					transform-origin='493.09px 62.4032px'
				/>
				<g className='animable' opacity='.3'>
					<path
						d='M467.86 45.87s25.68 44.8 31.46 42.49c7.46-3 19-52 19-52s-45.94 8.82-50.46 9.51Z'
						className='animable'
						fill='#fff'
						transform-origin='493.09px 62.4032px'
					/>
				</g>
				<path
					d='M502 64.58a.66.66 0 0 1-.45.85.7.7 0 0 1-.38 0 .83.83 0 0 1-.54-.6q0-.13-1.34-7c-.44 3.15-.79 5.64-1 7.46-.05.39-.08.6-.09.65a.79.79 0 0 1-.5.68h-.16a.79.79 0 0 1-.7-.4l-3.63-6.53q.71 3.91 1.18 7.2a.64.64 0 0 1-.45.84.59.59 0 0 1-.37 0 .79.79 0 0 1-.55-.59c0-.06-.56-3.13-1.63-9.23-.27-1.58-.42-2.43-.44-2.55a1.06 1.06 0 0 1 0-.31.68.68 0 0 1 .5-.51h.19a.53.53 0 0 1 .52.25c.3.57 1.22 2.25 2.75 5l2.13 3.89L498.53 53a.81.81 0 0 1 0-.2.79.79 0 0 1 .5-.49.73.73 0 0 1 .86.44c0 .16.06.35.11.57 1.24 6.68 1.91 10.42 2 11.26Z'
					className='animable'
					fill='#263238'
					transform-origin='496.487px 60.0235px'
				/>
				<path
					d='M521.23 35.58s29 42.73 34.59 40c7.21-3.53 15-53.27 15-53.27s-45.13 12.24-49.59 13.27Z'
					className='animable'
					fill='#f41760'
					transform-origin='546.025px 49.0077px'
				/>
				<path
					d='m545.41 42.68 5.13-2.06a1.25 1.25 0 0 1 .31-.07.64.64 0 0 1 .69.43.63.63 0 0 1 0 .27.84.84 0 0 1-.47.68l-4.61 1.84 1.17 4.59L551 47a1.07 1.07 0 0 1 .39-.07.67.67 0 0 1 .64.44.62.62 0 0 1 0 .23.82.82 0 0 1-.48.7L548 49.74l1.15 4.26 4.55-1.82a.94.94 0 0 1 .36-.08.71.71 0 0 1 .71.65.79.79 0 0 1-.47.72l-5.3 2.16a.73.73 0 0 1-.41 0 .82.82 0 0 1-.58-.54q0-.12-3-11.58a.72.72 0 0 1 0-.25.63.63 0 0 1 .4-.58Z'
					className='animable'
					fill='#263238'
					transform-origin='549.885px 48.1019px'
				/>
				<path
					d='M193.77 27.06s5.16 51.38 11.38 51.64C213.17 79 243.7 39 243.7 39s-45.52-10.73-49.93-11.94Z'
					className='animable'
					fill='#f41760'
					transform-origin='218.735px 52.8808px'
				/>
				<path
					d='M209.34 45.08a.58.58 0 0 1 .31.13.67.67 0 0 1 .27.63c-.52 1.83-.92 3.27-1.21 4.31-.71 2.53-1.08 4-1.14 4.33-.22 1.46 0 2.24.77 2.36a4.23 4.23 0 0 0 1.86-.15 10.18 10.18 0 0 1 .06-2.48 12.39 12.39 0 0 1 .41-1.86c.58-1.84 1.51-2.66 2.78-2.47a2 2 0 0 1 1.25.67 2.27 2.27 0 0 1 .46 1.89c0 .19-.07.4-.12.6a7.57 7.57 0 0 1-1.92 3.45 4.32 4.32 0 0 1-1.15.95c0 .16.17.26.44.3a4.49 4.49 0 0 0 3.75-1.52 14.47 14.47 0 0 0 2.84-4.11 4.23 4.23 0 0 1-2.37-1.18 3 3 0 0 1-.73-2.58 2.41 2.41 0 0 1 1.12-1.68 2.55 2.55 0 0 1 1.74-.38 2.79 2.79 0 0 1 1.86 1.06 3.18 3.18 0 0 1 .54 2.47c0 .22-.1.58-.22 1.07a2.63 2.63 0 0 0 .39-.06 5.7 5.7 0 0 0 1.23-.4 1.64 1.64 0 0 1 .85-.19.44.44 0 0 1 .24.11.6.6 0 0 1 .24.61c-.05.34-.39.63-1 .87a6.39 6.39 0 0 1-2.48.41 14.89 14.89 0 0 1-3 4.62 6.23 6.23 0 0 1-5.47 2.14h-.16a2 2 0 0 1-1.25-.87 5.76 5.76 0 0 1-2.71.23 1.93 1.93 0 0 1-1.21-.65 4.13 4.13 0 0 1-.5-3.3 25.13 25.13 0 0 1 1-4c.51-1.58.85-2.7 1-3.36-.62.28-1.11.49-1.47.64a3.46 3.46 0 0 1-1.06.36.68.68 0 0 1-.59-.8.83.83 0 0 1 .5-.58l.22-.1a14.74 14.74 0 0 1 3.63-1.49ZM211.52 56a3 3 0 0 0 .67-.54 5.3 5.3 0 0 0 1.5-3v-.16c0-.48-.14-.75-.55-.81s-.6.21-.89.73a7.55 7.55 0 0 0-.68 2.34 8.89 8.89 0 0 0-.05 1.44Zm5.77-7.18a1.42 1.42 0 0 0 .08.77c.27.68 1 1.1 2.18 1.28a7.89 7.89 0 0 0 .33-1.26 2.55 2.55 0 0 0 0-.73 1.18 1.18 0 0 0-1-1.07 1.47 1.47 0 0 0-.81.08 1.15 1.15 0 0 0-.78.9Z'
					className='animable'
					fill='#263238'
					transform-origin='214.44px 52.0617px'
				/>
				<path
					d='M619.08 6s-.41.18-1.21.5l-3.55 1.41-5.78 2.29-3.69 1.45-4.24 1.54-10 3.63-12 4c-2.15.75-4.39 1.42-6.71 2.13l-7.16 2.2c-1.22.38-2.47.77-3.74 1.14l-3.86 1.09-8 2.25a659.24 659.24 0 0 1-78.47 16.19c-15 2.07-30.7 3.82-47.08 5s-33.38 1.71-50.79 1.64l-13-.16-12.8-.47-3.17-.12-3.16-.19-6.28-.39-6.23-.38-6.16-.52c-4.09-.38-8.15-.64-12.16-1.1l-11.9-1.31c-3.92-.45-7.79-1-11.62-1.53l-5.71-.78-5.62-.9c-14.93-2.24-29-5.2-42.08-8.07-13.06-3.08-25.18-6.19-36.1-9.48l-8-2.39c-2.6-.76-5.09-1.65-7.54-2.44-4.88-1.61-9.51-3.07-13.75-4.66s-8.25-2.92-11.87-4.32l-9.89-3.88c-1.48-.59-2.89-1.12-4.2-1.67l-3.64-1.55-5.73-2.45-3.5-1.51c-.79-.34-1.19-.53-1.19-.53s.41.15 1.21.48l3.53 1.46c1.55.65 3.46 1.46 5.73 2.4l3.65 1.54c1.31.54 2.72 1.06 4.21 1.64l9.89 3.82c3.63 1.38 7.62 2.74 11.88 4.28s8.88 3 13.76 4.62c2.45.78 4.94 1.66 7.55 2.41l8 2.38C207.84 30 220 33.05 233 36.12c13.11 2.85 27.14 5.79 42.06 8l5.62.9 5.71.77c3.83.5 7.69 1.08 11.61 1.53l11.89 1.3c4 .45 8.07.72 12.15 1.09l6.16.52 6.22.38 6.28.38 3.15.19 3.17.12 12.8.47 13 .16c17.4.07 34.39-.53 50.76-1.63s32.1-2.94 47-5A663.65 663.65 0 0 0 549 29.25l8-2.24 4-1.08 3.74-1.12 7.16-2.18c2.32-.71 4.56-1.38 6.71-2.11l12-4 10-3.59 4.25-1.52 3.7-1.43 5.79-2.23 3.57-1.37Z'
					className='animable'
					fill='#455a64'
					transform-origin='373.29px 27.0631px'
				/>
			</g>
			<g id='confetti' className='animable'>
				<path
					d='M477.5 121.46a2.22 2.22 0 0 1-.9.05 3.61 3.61 0 0 1-2.25-1.28c-1.67-1.69-1.4-6 1.81-8.62a2.66 2.66 0 0 1 1.55-.42 2.19 2.19 0 0 1 1.54.66 2 2 0 0 1 .43 1.7 3.51 3.51 0 0 1-.83 1.61 6.38 6.38 0 0 1-7.18 1.3 5.59 5.59 0 0 1-2.92-2.92 6.66 6.66 0 0 1-.36-4.3 6.13 6.13 0 0 1 .93-2 3.94 3.94 0 0 1 1.77-1.47 2.15 2.15 0 0 1 1.21-.13 1.5 1.5 0 0 1 1 .71 2.69 2.69 0 0 1 0 2.38 6.71 6.71 0 0 1-7.78 3.49 6.4 6.4 0 0 1-3.45-2.59 6.79 6.79 0 0 1-1.16-4 4.85 4.85 0 0 1 1.59-3.59 3 3 0 0 1 1.81-.67 2.3 2.3 0 0 1 1.76.68 3 3 0 0 1 .31 3.38 4 4 0 0 1-2.66 1.76 5.67 5.67 0 0 1-2.91-.18 6.6 6.6 0 0 1-2.25-1.29 6.81 6.81 0 0 1-1.47-1.71 7 7 0 0 1-.79-1.72 6.21 6.21 0 0 1-.24-2.6 6 6 0 0 1 .19-.89s-.06.31-.12.9a6.2 6.2 0 0 0 .3 2.55 7.21 7.21 0 0 0 .8 1.67 6.94 6.94 0 0 0 1.45 1.66 6.6 6.6 0 0 0 2.2 1.22 5.45 5.45 0 0 0 2.79.14 3.6 3.6 0 0 0 2.47-1.65 2.66 2.66 0 0 0-.28-3 2.39 2.39 0 0 0-3.17 0 4.52 4.52 0 0 0-1.46 3.36 6.43 6.43 0 0 0 1.12 3.78 6.07 6.07 0 0 0 3.26 2.46 6.39 6.39 0 0 0 7.37-3.31 2.37 2.37 0 0 0 0-2.06 1.19 1.19 0 0 0-.79-.55 1.77 1.77 0 0 0-1 .11 3.61 3.61 0 0 0-1.62 1.35 5.71 5.71 0 0 0-.88 1.93 6.35 6.35 0 0 0 .33 4.09 5.3 5.3 0 0 0 2.75 2.76 6.1 6.1 0 0 0 6.84-1.2 3.37 3.37 0 0 0 .77-1.47 1.7 1.7 0 0 0-.36-1.47 1.92 1.92 0 0 0-1.35-.58 2.37 2.37 0 0 0-1.41.37 5.41 5.41 0 0 0-1.81 2.12 8.36 8.36 0 0 0-.86 2.38 4.49 4.49 0 0 0 .83 3.83 3.62 3.62 0 0 0 2.15 1.29 5.56 5.56 0 0 0 .93-.02Z'
					className='animable'
					fill='#263238'
					transform-origin='467.869px 110.167px'
				/>
				<path
					d='M330.92 239.55s-.08.06-.24.14l-.74.38a25.38 25.38 0 0 0-2.7 1.65 23.78 23.78 0 0 0-7.55 8.69 16.94 16.94 0 0 0-2 7.65 8.46 8.46 0 0 0 1.14 4.19 6.6 6.6 0 0 0 3.42 2.94 3.93 3.93 0 0 0 2.3.16 2.29 2.29 0 0 0 1.72-1.36 2.09 2.09 0 0 0-.61-2.11 3.61 3.61 0 0 0-2.21-1 13.65 13.65 0 0 0-2.63 0 20.53 20.53 0 0 0-2.67.41 14.58 14.58 0 0 0-5 2.05c-3.06 2-5 5.78-4.15 9.16a5.71 5.71 0 0 0 3 3.82 3.89 3.89 0 0 0 4.37-.75 3 3 0 0 0 1-2 3.25 3.25 0 0 0-.6-2.07 4.48 4.48 0 0 0-3.69-1.86 8.48 8.48 0 0 0-6.75 3.5 8.64 8.64 0 0 0-1.76 6.14 9.44 9.44 0 0 0 4.11 6.71c.6.4 1 .55.94.58a4.9 4.9 0 0 1-1-.49 8.82 8.82 0 0 1-2.38-2.12 9.41 9.41 0 0 1-2-4.65 9.19 9.19 0 0 1 8.81-10.1 4.87 4.87 0 0 1 4.05 2 3.7 3.7 0 0 1 .7 2.36 3.56 3.56 0 0 1-1.09 2.28 4.53 4.53 0 0 1-2.3 1.2 4.31 4.31 0 0 1-2.62-.34 6.16 6.16 0 0 1-3.27-4.15 8.25 8.25 0 0 1 .64-5.45 10.44 10.44 0 0 1 3.71-4.26 15.2 15.2 0 0 1 5.23-2.13 21.7 21.7 0 0 1 2.73-.41 13.93 13.93 0 0 1 2.74 0 4.09 4.09 0 0 1 2.51 1.13 2.6 2.6 0 0 1 .72 2.63 2.74 2.74 0 0 1-2.08 1.67 4.32 4.32 0 0 1-2.57-.18 7 7 0 0 1-3.66-3.16 8.83 8.83 0 0 1-1.17-4.41 17.15 17.15 0 0 1 2.11-7.82 23.39 23.39 0 0 1 7.75-8.7 16.76 16.76 0 0 1 3.74-1.92Z'
					className='animable'
					fill='#263238'
					transform-origin='317.557px 263.06px'
				/>
			</g>
			<g id='balloons' className='animable'>
				<path
					d='M146.33 200.57a5 5 0 0 1-.62-.6 8.44 8.44 0 0 1-1.36-2.08 9.56 9.56 0 0 1-.86-3.84 9 9 0 0 1 1.47-5 36.25 36.25 0 0 1 4.08-4.81 19.42 19.42 0 0 0 2.11-2.75 8.71 8.71 0 0 0 1.28-3.39 7 7 0 0 0-.57-3.72 16.35 16.35 0 0 0-2.12-3.41c-.84-1.09-1.76-2.16-2.6-3.33a16.14 16.14 0 0 1-2.09-3.86 9.71 9.71 0 0 1-.57-4.36 7.49 7.49 0 0 1 1.7-3.91 5.55 5.55 0 0 1 3.61-2 3.22 3.22 0 0 1 2 .41 2.15 2.15 0 0 1 1 1.75 1.91 1.91 0 0 1-1.09 1.64 2.48 2.48 0 0 1-1.9.18 6 6 0 0 1-2.82-2.16 12.45 12.45 0 0 1-2.41-5.82 19 19 0 0 1 0-5.2 33 33 0 0 1 .71-3.87c.24-1 .46-1.85.61-2.4.07-.26.13-.46.18-.62a.8.8 0 0 1 .07-.21s0 .08 0 .22-.08.37-.14.63l-.54 2.41a37.25 37.25 0 0 0-.64 3.86 19.07 19.07 0 0 0 .1 5.14 12.28 12.28 0 0 0 2.4 5.66 5.66 5.66 0 0 0 2.65 2.05 2.23 2.23 0 0 0 1.66-.17 1.57 1.57 0 0 0 .9-1.34 1.8 1.8 0 0 0-.86-1.45 2.87 2.87 0 0 0-1.79-.35 5.18 5.18 0 0 0-3.36 1.87 7.12 7.12 0 0 0-1.61 3.72 9.25 9.25 0 0 0 .56 4.18 15.74 15.74 0 0 0 2 3.77c.83 1.15 1.75 2.22 2.59 3.33a16.46 16.46 0 0 1 2.16 3.49 7.48 7.48 0 0 1 .59 3.91 9.12 9.12 0 0 1-1.35 3.51 19.68 19.68 0 0 1-2.16 2.79 36.06 36.06 0 0 0-4.08 4.74 8.79 8.79 0 0 0-1.49 4.83 9.57 9.57 0 0 0 .78 3.78 8.81 8.81 0 0 0 1.29 2.09c.33.47.54.68.53.69Z'
					className='animable'
					fill='#263238'
					transform-origin='148.176px 168.89px'
				/>
				<path
					d='M151 94.28c-8.92-1.19-15.49 3.48-18.42 10.61s-1.49 15.48 2.23 22.23c2.06 3.75 5.15 7.36 9.35 8.22a12.09 12.09 0 0 0 9.77-2.79 26.41 26.41 0 0 0 6.34-8.3c2.95-5.5 4.72-11.72 4-17.92-.59-5.44-6.17-11.24-13.3-12'
					className='animable'
					fill='#f41760'
					transform-origin='147.723px 114.79px'
				/>
				<path
					d='M145.52 134.76c-.33.46-1.05 2.07-1.3 2.57a.9.9 0 0 0-.12.77.63.63 0 0 0 .78.26 1.76 1.76 0 0 0 .71-.56.86.86 0 1 0 1.67-.37 1.63 1.63 0 0 0 .67.58.53.53 0 0 0 .7-.37.8.8 0 0 0-.23-.51c-.59-.74-1.18-1.47-1.76-2.21'
					className='animable'
					fill='#f41760'
					transform-origin='146.346px 136.662px'
				/>
				<path
					d='M618.1 297.87a5 5 0 0 1-.62-.6 8.44 8.44 0 0 1-1.36-2.08 9.56 9.56 0 0 1-.86-3.84 9 9 0 0 1 1.48-5 36 36 0 0 1 4.07-4.81 19.42 19.42 0 0 0 2.11-2.75 8.65 8.65 0 0 0 1.28-3.39 7 7 0 0 0-.57-3.72 16.35 16.35 0 0 0-2.12-3.41c-.84-1.09-1.76-2.16-2.6-3.33a16 16 0 0 1-2.09-3.86 9.71 9.71 0 0 1-.57-4.36 7.42 7.42 0 0 1 1.71-3.91 5.54 5.54 0 0 1 3.6-2 3.21 3.21 0 0 1 2 .41 2.15 2.15 0 0 1 1 1.75 1.91 1.91 0 0 1-1.09 1.64 2.53 2.53 0 0 1-1.9.19 6 6 0 0 1-2.81-2.17 12.57 12.57 0 0 1-2.42-5.82 18.54 18.54 0 0 1 0-5.2 35.44 35.44 0 0 1 .7-3.87c.24-1.05.46-1.85.61-2.4.07-.26.13-.46.18-.62a.8.8 0 0 1 .07-.21.89.89 0 0 1 0 .22l-.14.63-.54 2.41a38.19 38.19 0 0 0-.64 3.86 19.07 19.07 0 0 0 .1 5.14 12.31 12.31 0 0 0 2.4 5.67 5.69 5.69 0 0 0 2.65 2 2.23 2.23 0 0 0 1.66-.17 1.55 1.55 0 0 0 .9-1.34 1.78 1.78 0 0 0-.86-1.45 2.86 2.86 0 0 0-1.79-.35 5.16 5.16 0 0 0-3.35 1.87 7.05 7.05 0 0 0-1.62 3.72 9.31 9.31 0 0 0 .56 4.19 15.67 15.67 0 0 0 2 3.76c.83 1.15 1.75 2.22 2.59 3.33a16.46 16.46 0 0 1 2.16 3.49 7.48 7.48 0 0 1 .59 3.91 9.2 9.2 0 0 1-1.34 3.51 19.9 19.9 0 0 1-2.17 2.79 36.06 36.06 0 0 0-4.08 4.74 8.79 8.79 0 0 0-1.49 4.83 9.39 9.39 0 0 0 .79 3.78 8.84 8.84 0 0 0 1.28 2.09c.34.51.55.72.54.73Z'
					className='animable'
					fill='#263238'
					transform-origin='619.941px 266.19px'
				/>
				<path
					d='M622.72 191.59c-8.92-1.2-15.48 3.47-18.42 10.6s-1.49 15.48 2.23 22.23c2.06 3.75 5.15 7.36 9.35 8.22a12.12 12.12 0 0 0 9.78-2.79 26.53 26.53 0 0 0 6.33-8.3c3-5.5 4.72-11.72 4-17.92-.6-5.44-6.18-11.23-13.31-12'
					className='animable'
					fill='#455a64'
					transform-origin='619.443px 212.094px'
				/>
				<path
					d='M617.29 232.06c-.33.46-1 2.07-1.3 2.58a.91.91 0 0 0-.12.76.64.64 0 0 0 .79.26 1.8 1.8 0 0 0 .7-.56.86.86 0 1 0 1.67-.37 1.62 1.62 0 0 0 .67.58.53.53 0 0 0 .7-.37.75.75 0 0 0-.23-.51c-.59-.73-1.17-1.47-1.76-2.21'
					className='animable'
					fill='#455a64'
					transform-origin='618.117px 233.962px'
				/>
				<path
					d='M445.15 382a7.61 7.61 0 0 1-.76-.74 10.23 10.23 0 0 1-1.67-2.54 11.62 11.62 0 0 1-1.05-4.7 10.94 10.94 0 0 1 1.8-6.09 44 44 0 0 1 5-5.9 23 23 0 0 0 2.53-3.33 10.41 10.41 0 0 0 1.56-4.12 8.57 8.57 0 0 0-.7-4.54 19.43 19.43 0 0 0-2.59-4.16c-1-1.34-2.15-2.65-3.18-4.08a19.58 19.58 0 0 1-2.55-4.73 11.76 11.76 0 0 1-.71-5.34 9.13 9.13 0 0 1 2.1-4.81 6.74 6.74 0 0 1 4.42-2.43 3.85 3.85 0 0 1 2.48.5 2.66 2.66 0 0 1 1.26 2.17 2.36 2.36 0 0 1-1.35 2 3.11 3.11 0 0 1-2.35.23 7.34 7.34 0 0 1-3.45-2.66 15.26 15.26 0 0 1-3-7.12 22.8 22.8 0 0 1 0-6.38 42.37 42.37 0 0 1 .86-4.73c.3-1.28.57-2.26.76-2.93.09-.31.16-.56.21-.76s.09-.26.1-.25a1.27 1.27 0 0 1 0 .26c-.05.21-.1.46-.17.77l-.66 3a44.12 44.12 0 0 0-.77 4.71 23.13 23.13 0 0 0 .12 6.29 15.07 15.07 0 0 0 2.93 6.91 6.83 6.83 0 0 0 3.24 2.49 2.68 2.68 0 0 0 2-.2 1.9 1.9 0 0 0 1.09-1.62 2.15 2.15 0 0 0-1-1.74 3.41 3.41 0 0 0-2.17-.43 6.32 6.32 0 0 0-4.09 2.28 8.7 8.7 0 0 0-2 4.53 11.41 11.41 0 0 0 .69 5.11 19.07 19.07 0 0 0 2.48 4.6c1 1.4 2.13 2.71 3.16 4.07a20 20 0 0 1 2.65 4.28 9 9 0 0 1 .72 4.79 11.15 11.15 0 0 1-1.65 4.3 22.91 22.91 0 0 1-2.65 3.41 44.43 44.43 0 0 0-5 5.81 10.64 10.64 0 0 0-1.82 5.89 11.36 11.36 0 0 0 1 4.61 10.49 10.49 0 0 0 1.56 2.56c.38.51.64.76.62.76Z'
					className='animable'
					fill='#263238'
					transform-origin='447.414px 343.279px'
				/>
				<path
					d='M450.81 252c-10.91-1.46-18.95 4.26-22.53 13s-1.83 18.94 2.72 27.19c2.53 4.6 6.3 9 11.44 10.06 4.19.86 8.62-.73 12-3.42s5.72-6.37 7.74-10.14c3.62-6.73 5.77-14.34 4.94-21.93-.73-6.65-7.55-13.74-16.27-14.73'
					className='animable'
					fill='#f41760'
					transform-origin='446.832px 277.129px'
				/>
				<path
					d='M444.16 301.53c-.4.56-1.28 2.53-1.59 3.15a1.1 1.1 0 0 0-.14.94.78.78 0 0 0 1 .31 2.26 2.26 0 0 0 .86-.68 1 1 0 1 0 2-.46 1.89 1.89 0 0 0 .83.71.65.65 0 0 0 .85-.45 1 1 0 0 0-.28-.62l-2.16-2.71'
					className='animable'
					fill='#f41760'
					transform-origin='445.176px 303.788px'
				/>
			</g>
			<defs>
				<filter height='200%'>
					<feMorphology in='SourceAlpha' result='DILATED' operator='dilate' radius='2' />
					<feFlood floodColor='#32DFEC' floodOpacity='1' result='PINK' />
					<feComposite in='PINK' in2='DILATED' operator='in' result='OUTLINE' />
					<feMerge>
						<feMergeNode in='OUTLINE' />
						<feMergeNode in='SourceGraphic' />
					</feMerge>
				</filter>
				<filter height='200%'>
					<feMorphology in='SourceAlpha' result='DILATED' operator='dilate' radius='2' />
					<feFlood floodColor='red' floodOpacity='.5' result='PINK' />
					<feComposite in='PINK' in2='DILATED' operator='in' result='OUTLINE' />
					<feMerge>
						<feMergeNode in='OUTLINE' />
						<feMergeNode in='SourceGraphic' />
					</feMerge>
					<feColorMatrix values='0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0' />
				</filter>
			</defs>
		</svg>
	)
}

export default GetStartedSvg
